module.exports = {
  "+1Wujb": "{num} 個のアイテム",
  "+4lD9e": "名前",
  "+L9lak": "アラームテンプレートを適用",
  "+bRanp": "通知の最大数を入力してください",
  "+d7aNN": "アラームテンプレートリスト",
  "/COTHZ": "アラーム モジュール名を空にすることはできません",
  "/cqdKk": "ダウンロード",
  "/l9tS2": "トリガーされません",
  "/sI6h+": "",
  "03eM6t": "200 項目/ページ",
  "0JCY6+": "デプロイヤー",
  "0sn8j/": "あなたの名前を入力してください",
  "1UXyeT": "トリガー時間",
  "1WymPU": "アラームトリガー値を選択",
  "2+X2n8": "一括削除",
  "28oE7E": "デバイスが選択されていません",
  "29A4OA": "会社メンバー",
  "2QzYmY": "キャンセル",
  "z9+Z7p": "タグを選択",
  "5EJNIu": "企業間で機器を検索",
  P76mDe: "同期ファイル管理",
  "2rDc7R": "アラーム ルールを空にすることはできません",
  "2t0Cct": "導入日",
  "32AbcK": "会社を選択",
  "36+mbi": "処理ステータス",
  pGioLb: "デバイスシーケンス SN",
  wDqNy1: "例",
  "wnPTP+": "デバイス SN を入力してください",
  i5Nyva: "未読",
  ich0wH: "デバイス SN",
  wpKIvP: "読み取り",
  "3HzQUc": "JSON をエクスポート",
  "3RVwfq": "コメントを記入してください",
  "3aYG4L":
    "デバイスに現在適用されているアラーム テンプレートを削除し、アラームの監視と送信を行わなくなります",
  "3qVnoZ": "デバイスの数 ({num})",
  "4/e9qs": "名前を入力してください",
  "4VVrWd":
    "アラーム テンプレート ({name}) を無効にしてもよろしいですか? 無効にすると、新しいアラーム デバイスはテンプレートを適用できなくなります。",
  "4vWL+W": "デバイスをインポート",
  "4wi+/p": "テンプレート",
  "5SSVAQ": "新しいアラーム テンプレート",
  "5grmob": "メールアドレスを入力してください",
  "5p8cBO": "アカウント管理",
  "60Ixlm": "アラームテンプレート名",
  "6ABIlp": "トリガーステータス",
  "6mjOF/": "一括リセット",
  "7G1c4h": "デバイスリスト",
  "8PESa6": "無効にする",
  "919TK9": "サポートされている形式: xls、xlsx",
  "9Kfib+": "不明なエラー",
  "9UefLp": "ラベル",
  B57Wbu: "デバイスが選択されていません",
  BC74I9: "プロンプトメッセージ",
  BQcLxf: "下に移動",
  BYbqwY: "ファイルをここにドラッグするか、クリックしてアップロードします",
  BhkglP: "トークンを表示",
  BwXapw: "カテゴリ名は500文字以内で管理してください",
  CLqPBU: "編集",
  D3lDHK: "アラーム ルールを追加",
  D5HOUz: "ステータスを選択",
  E2kRYi: "バッチ有効",
  "EZ+vMa": "テンプレートの注釈",
  EwM8Kj: "引っ越してもよろしいですか?",
  Ey9rBq: "削除してもよろしいですか?",
  F2LJDJ: "削除してもよろしいですか?",
  F56ZKt: "メンバーを選択",
  FEb7U2: "確認",
  "FaJ/jI": "インポートするファイルが選択されていません",
  FbCeo1: "トリガー値",
  FbsCUK: "携帯電話",
  FeJVkL: "受信者を追加する",
  "Fr1I/b": "ラベル",
  "G+BH4o": "現在のデバイス ({name}) を削除してもよろしいですか?",
  GKSW97: "バッチを無効にする",
  GQ5EVQ: "少なくとも 1 つチェックしてください",
  GUMdjP: "最終実行ステータス",
  Gk0Mt5:
    "アラーム デバイス ({name}) をリセットしてもよろしいですか? リセット後も、アラーム ルールは引き続き監視されます。",
  GujK99:
    "アラーム テンプレートの内容が後で更新されると、適用されたデバイスにも同期されます",
  HN1dNJ: "すべてのアカウント",
  IqkgWZ: "キーワード",
  "Iwt/8W": "注釈",
  "J0D5h+": "開始時刻",
  J9jPRL: "コピーが成功しました",
  JJl2M9: "エクスポート",
  JeJAmT: "名前を変更",
  Jh62y5: "すべてのデバイス",
  Jp7u8z: "",
  LWSLHa: "暖かいリマインダー",
  Ls1X2Z: "処理済み",
  "LuP+H0": "説明",
  LwhdsE: "複数の選択を切り替える",
  MnTdIi: "トリガーの数",
  MvGPdx:
    "({name}) アラーム テンプレートを有効にしてもよろしいですか? 有効にすると、新しいアラーム デバイスがテンプレートを適用できるようになります。",
  N4np50: "通知の最大数",
  NTanl8: "アラームテンプレートを追加",
  NW8FV4: "デバイスコマンドステータス",
  OsMncl: "オンになっていません",
  "P/eul9": "いいえ",
  P6YSaZ: "アラーム履歴",
  PgNsL5: "展開中",
  "Py/5UG": "操作中のノードは存在しません。再度操作してください。",
  "Q2/NzC": "{num} 台のデバイスが選択されました",
  QHhMxE: "キャラクターを選択",
  QV3pnn: "ステータス",
  "QavrS/": "ルール名",
  QwHI8Q: "クエリ結果:",
  R2D5Dv: "作成時間",
  R3TTCW: "アラームテンプレートを編集",
  S57QRB: "フィルター条件",
  SGDlQ6: "合計 {total} 個のアイテム",
  T3CtvK: "カテゴリ名を空にすることはできません",
  TDuPUp: "トリガー",
  TqDOFU: "確認コードを頻繁に送信しないでください!",
  U2DqqT: "会社を検索",
  UBbWUL: "テンプレートが選択されていません",
  UFjZVV: "展開ステータス",
  UUtqvk: "未処理",
  UcumBq: "アラーム通知",
  UtE0dS: "操作",
  "Uu/nFu":
    "このデバイスに適用されているすべてのアラーム テンプレートを削除します",
  V0RiZp: "操作は成功しました",
  VR6zMp: "無効にしてもよろしいですか?",
  VRizgn: "携帯電話番号を入力してください",
  ViVQNi: "役割",
  WeKYMe: "ラストオーダー時間",
  Wp6QLH:
    "アラーム ルール ({name}) のリセットを確認しますか? リセット後、アラーム ルールは引き続き監視されます。",
  "WwRq+y": "アラーム通知オブジェクトを追加してください",
  "X/cNgA": "リマインダーを削除",
  XFEq9J: "テンプレートのステータス",
  XG2wHz: "展開は成功しました",
  XMBOec: "タグを削除",
  XeiAal: "削除",
  XgmTAk: "デバイスのシリアル番号",
  YBAsWB: "グループコマンド",
  YpXN8m: "最後のトリガー時間",
  ZETl7o: "アラームテンプレート",
  ZMUuo8: "有効にしてもよろしいですか?",
  ZPSpaL: "アラームモジュール名",
  ZUPzqr: "オンにする",
  "Zvt+2g": "倉庫",
  aBleoN: "アラーム テンプレートを選択",
  "aN+DgN": "起動時間",
  aiBGBs: "正常に削除されました",
  "arp+TQ": "50 項目/ページ",
  "bE+h3K": "デバイスのステータス",
  bOKDVF: "無線選択の切り替え",
  bqbDVw: "クエリ",
  cDZ00w: "表示",
  drCsUI: "会社",
  e8OyHO: "20 項目/ページ",
  f7Dpbl:
    "テンプレートをダウンロードし、テンプレートのプロンプトに従ってコンテンツを改善します",
  fz2pkM: "このノードは削除されました",
  gU4eZD: "アラーム管理",
  ggvI6Z: "すべて選択",
  gomg5W: "リマインダーを無効にする",
  gzHM5l: "アラーム解除日",
  "hDx3/S": "メール",
  hMboy7: "コマンドステータスの詳細",
  iKomBu: "まだ分類されていません",
  ieTzi7: "アラーム テンプレートの詳細",
  ifGp4v: "2FA",
  iyOrrD: "100 アイテム/ページ",
  j6IHvr: "詳細を表示",
  jT6zKT: "デバイスの数",
  jdbKm7: "アラーム通知オブジェクト",
  jddlWH: "デプロイに失敗しました",
  kCh5Jz: "ヒント",
  kG2Etz: "オンライン",
  khyRcw: "Excel ファイルを選択してください",
  kwOS33: "リマインダーを有効にする",
  l1fZNE: "すべてのボックスのチェックを外すことはできません",
  loTFGc: "名前なし",
  m0Qdyj: "検証に失敗しました",
  ma6S6y: "カスタマイズされた表示",
  "mpeFt+": "アラーム ルール",
  nH1F3p: "({name}) の現在のアラーム ルールを削除してもよろしいですか?",
  nJCPaY:
    "ユーザーには電子メール アドレスがバインドされていないため、検証できません",
  nUSeQB: "アカウントが選択されていません",
  nw8orn: "通知された人の数",
  pBPyFt: "Nubis バージョン",
  "pV2t/S": "基本情報",
  pcU9bM: "メンバーを追加",
  q6qKtH: "クエリ条件:",
  qUKj7E: "コピー",
  "r0/TUu": "OK",
  "r2dEd/": "リセット",
  s9U9qn: "アラームを設定",
  sOIerB: "アクティブ化されていません",
  sZSyGZ: "有効",
  srEpKw: "アップロード中",
  srpWCM: "表示する必要があるフィールドをチェックし、ドラッグして並べ替えます",
  t2iHNJ: "更新",
  "tCh+iz": "アラーム解除時刻",
  tLW3W3: "携帯電話番号",
  tokMPz: "例外オブジェクト",
  "uoZwj+": "クリエイター",
  v04auv: "終了時刻",
  w8L9Kj: "アラーム ルールを構成する",
  wOHHSJ: "上に移動",
  wQAiLI: "リセットリマインダー",
  xISm1t: "アクティブ化",
  xUjLTE: "検索",
  y9NWzQ: "警報装置リスト",
  yGWx2z: "パラメータエラー",
  yOMNOj: "はい",
  yReEcE: "タグを選択",
  yXsHgv: "10 項目/ページ",
  yb3AuG: "オフライン",
  ybGQQ3: "関連する結果はありません",
  "yiO/gL": "テンプレートリスト",
  yxPDHk: "リリースステータス",
  zH7h1q: "履歴",
  "96Mzoq": "完了",
  ByhhM1: "条件",
  PcCooF: "アラームトリガー値",
  RUMaeu: "アラームルールを完全に入力してください",
  h7w4pz: "まだデータがありません",
  nMMNa6: "電子メール、SMS、またはシステム経由で通知します。",
  "nOE0/j": "会社とメンバーの検索",
  q6WPYA:
    "選択したデバイスには {num} 個の Nubis Free バージョンが含まれており、グループでコマンドを送信することはできません",
  "+CP3nr": "タスクを選択",
  "+gbx50": "アラーム状態",
  "+wet4N": "認証コードエラー",
  "/BzHXM": "作成者を選択",
  "/SqqyP": "デバイスのシリアル番号を入力してください",
  "0YYUNG": "{num} 個のタグが選択されました",
  "1M03Dq": "スケジュールテンプレート",
  "1SslIM": "アプリケーションを閉じる",
  "1gjtU2": "最終実行時刻",
  "1sj5Sj":
    "このデバイスに適用されているすべてのスケジュール テンプレートを削除します",
  "2MYr1m": "ログイン",
  "2l+gFk":
    "スケジュール テンプレート ({name}) を有効にしてもよろしいですか? 有効にすると、デバイスはテンプレートを参照できるようになります。",
  "2opnVU": "実行中",
  "2r/XUW":
    "このタグによって適用されたすべてのスケジュール テンプレートを削除します",
  "3xlnbE": "コマンド時間",
  "47GdDb": "閉じる",
  "5ytYaf": "新しいスケジュール テンプレート",
  "65DvZ1": "入力上限：4",
  "6x6nu5": "実際の実行時間",
  "8zN+hZ": "アプリケーションを実行",
  "9UZxwP": "確認コードを入力してください",
  "9kkcTB": "スケジュールテンプレートを削除",
  "9ljNkr": "再送信",
  "A/eXwT":
    "このラベルに適用されているすべてのアラーム テンプレートを削除します",
  AyWMlZ: "スケジュールされたタスクを追加",
  BiPxfI: "スケジュール テンプレートを追加",
  C6cGK1: "スケジュールテンプレート名を空にすることはできません",
  EGvInA: "機器アラームリスト",
  Ft60hS: "Nubis デバイス",
  Gwj7xc: "デフォルトに戻す",
  H15ECl: "入力アプリケーション",
  "J3BW/8": "メールで受け取った確認コードを入力してください",
  KW8qOm: "テンプレートを選択",
  LADN1a: "スケジュール実行ステータス",
  Lfia0v: "スケジュールを設定",
  NDmD8V: "スケジュール テンプレート ({name}) を削除してもよろしいですか?",
  OVecAI: "成功",
  OwtOn5: "合計ステータス",
  PTc6Gt: "スケジュールを有効にする",
  PaMvre: "アラームルールリスト",
  PnYplH: "機器",
  RNaGVr: "タスク失敗リスト",
  RWBRyt: "装備分布図は作成中です",
  "RuFFf/":
    "スケジュール テンプレート ({name}) を無効にしてもよろしいですか? 無効にすると、デバイスはテンプレートを参照できなくなります。",
  SPyEF8: "モードを選択",
  SwMBFl: "スケジュール テンプレートを適用",
  TDSTTj: "スケジュール テンプレートを選択",
  UMU42c: "デバイスを選択",
  Unvxiq: "アカウントを切り替える",
  WxPZOH: "{num} 回実行します",
  WypzMq: "スケジュールされたタスク",
  X2m4ec: "スケジュール テンプレートを無効にする",
  "YIgP+p": "デバイススケジュールリスト",
  LNGTru: "デバイススケジューリング失敗リスト",
  YwEzx2: "表示する必要があるフィールドを確認してください",
  Z2B362: "連続",
  ZBDct6: "失敗しました: {num}",
  ZHAjhZ: "入力上限：30",
  Zr9Dss: "失敗しました",
  azDNha: "正常に送信されました",
  b5l2vN: "保存",
  b6y8Ai: "({name}) スケジュールを無効にしてもよろしいですか?",
  bYIKFB: "進行中: {num}",
  "e/6XZC": "確認コードを受信しませんでしたか?",
  eAgY2G: "子会社の拡大",
  fl7J8Y: "メッセージ",
  "gH+Az7": "スケジュールを無効にする",
  gi4oTZ: "スケジュールテンプレートリスト",
  gplM71: "毎日",
  "hAd+eG": "設備スケジュールカレンダー",
  "hD7/Lu": "ディスプレイ",
  hYN7oM: "非表示",
  hfn1Ux: "成功/合計",
  hkJXyi: "スケジュールされたタスクを構成する",
  "hkR3E+": "表示モード",
  hwlmeB: "ターゲットの種類",
  iN7Lps: "ループモード",
  iscUWH: "完了: {num}",
  "j/YGZ0": "マップ",
  j6Hm96: "スケジュールされた実行",
  jNxbTC: "検証コードを空にすることはできません",
  js3tZs: "スケジュールテンプレート名",
  k9dozc: "実行時間",
  kUagYW: "スケジュール実行履歴",
  l7IiCY: "スケジュールステータス",
  "lzP/we": "ORA ダウンロード",
  m1h20o:
    "後続のスケジュール テンプレートの内容が更新された場合、適用されたデバイスにも同期されます",
  "mC2//O": "スケジュールカレンダーを表示",
  mFIXSq: "デバイスのシリアル番号",
  mISQTh: "詳細",
  nGubXb: "スケジュールテンプレートの詳細",
  nqPJwo: "タグ用",
  oCogiy: "コマンド",
  oY0m24: "ユーザー",
  oirnwv: "スケジュール テンプレートを有効にする",
  ojz0Ke: "もっと見る >",
  oru5FY: "スケジュールテンプレートを編集",
  "p+zOzc": "結果",
  peNVzr: "{num} 週間ごと",
  pfGGi0:
    "現在デバイスに適用されているスケジュール テンプレートを削除し、実行しなくなります",
  pielKO: "ブートデバイス",
  pkYJKs: "実行ステータス",
  qhC4wy: "デバイスを検索",
  rUHCoM: "機器のスケジュール設定",
  sb1vdX: "進行中",
  u3dVQz: "毎週",
  "urr92/": "デプロイヤを選択します",
  vovKL8: "アプリケーション パスを空にすることはできません",
  "wrU/Kc": "{num} 日ごと",
  ygAHaf: "送信時間",
  zvaxmN: "スケジュール管理",
  "2ffDGT":
    "スケジュールされたタスクを閉じてもよろしいですか? 閉じた後、デバイスはスケジュール テンプレートを実行しません。",
  "D//rZg":
    "スケジュールテンプレートのアプリケーションを削除してもよろしいですか?",
  E1GPl7: "所有者",
  EwTMGn: "({name}) スケジュールを有効にしてもよろしいですか?",
  GpzsBd: "スケジュールされたタスクを開く",
  IM8kXz: "({name}) のアプリケーションを削除してもよろしいですか?",
  KXqGQe: "一括起動",
  NGe0Cs: "スケジュール実行レコードを削除",
  SkK50H: "スケジュールされたタスクを追加してください",
  Trt6ju:
    "スケジュールされたタスクを開始してもよろしいですか? 開始後、デバイスはスケジュールされたタスクを実行する必要があります。",
  UiVtQS: "バッチを閉じる",
  "Z56D+X": "スケジュールされたタスクを閉じる",
  aKxrop: "スケジュールテンプレートのアプリケーションを削除",
  miANEg:
    "({name}) スケジュールされたタスクを閉じてもよろしいですか? 閉じた後、デバイスはスケジュールされたタスクを実行しません。",
  ngLF8L: "({name}) のスケジュール実行レコードを削除してもよろしいですか?",
  nqPOJc:
    "スケジュールされたタスク ({name}) を開きますか? 開いた後、デバイスはスケジュールされたタスクを実行する必要があります。",
  oV0gpL: "発売予定日",
  xtHJEE: "レコードが選択されていません",
  yifWnc: "スケジュール実行記録を削除してもよろしいですか?",
  "+/R6RX": "タスクのステータス",
  "35v5wD": "アラーム履歴をリセットしてもよろしいですか?",
  "3QXG/d": "Ora バージョン",
  "5jpkHg": "オンラインステータス",
  G4XFn6: "ハードウェアモデル",
  Ko5CPO: "アラーム履歴をリセットしてもよろしいですか?",
  ajVpLe: "このアラーム履歴を削除してもよろしいですか?",
  dEXfrL: "デバイスの健全性ステータスの間隔",
  eCCa0L: "タスクの種類",
  fr4nkj: "アラーム履歴を削除してもよろしいですか?",
  nzsNwZ: "デバイスの健康状態",
  qDba8m: "オフラインデバイスステータス",
  rDRAr0: "オペレーティング システムのバージョン",
  YeF1dY: "タイムゾーン",
  BC52ne: "無視されました",
  SbZhau: "ブートタスクはブートデバイスを指定する必要があります",
  "lsLYU/": "通知の最大数は 10 を超えることはできません",
  "NM/lRq": "アップロードをキャンセル",
  "3qF993": "現在の会社にないデバイスを譲渡することはできません。",
  "6+iYA0": "シリアル番号",
  yc6ZUL: "Ora 最終更新ステータス",
  UA7mv6: "Ora 最終更新時刻",
  "fOwU1/": "所属",
  jNiwk6: "警報装置 ({name}) を削除してもよろしいですか?",
  "lLa/D3": "適用タイプ",
  "wk1c/l": "デバイスのグレースケール更新期間に応じて (現地時間)",
  "5+oaTO": "イメージの最終更新ステータス",
  "6pDRb2": "有効なパスワードを入力してください",
  ANeFu6: "パスワードを確認してください",
  GnzEo7: "画像の最終更新時刻",
  s7NSze: "操作を確認する前にアカウントのパスワードを入力してください。",
  "9RNrDU": "プロキシデバイスかどうか",
  "+TzicH": "商人",
  "/CxA3j": "サブマーチャントを追加",
  "4c3uw8": "販売者を削除",
  "5Hy0Qx": "同じ販売者に譲渡することはできません",
  BBpRbn:
    "この販売者によって適用されたすべてのアラーム テンプレートを削除します",
  DADacD:
    "この販売者によって適用されたすべてのスケジュール テンプレートを削除します",
  G9WbnV: "販売者向け",
  S1QSWC: "サブマーチャントをインポート",
  TYAJpp: "{num} 件の販売者が選択されました",
  Ve9Ksw: "転送商人",
  Wzv7kF: "販売者を選択してください",
  h7Yvwt: "クロスマーチャント",
  jAAXdQ: "機器販売業者",
  "kr+7Iy": "販売者を検索",
  tFr3tb:
    "アラーム テンプレート ({name}) を削除してもよろしいですか? 削除後、デバイス、マーチャント、ラベルによるこのテンプレートの適用は同時にキャンセルされます。",
  uuRzdk: "販売者に帰属します",
  vD5wnY:
    "所属する加盟店にチェックを入れるということは、加盟店の許可を得ていることを意味します",
  zyMKgy: "販売者を選択",
  RndUeh: "推定実行時間",
  gcHeN9:
    "OS アプリケーション名を入力してください。例: Windows:chrome または Android:com.android.chrome",
  EM8lAi: "デバイスの更新可能期間 (現地時間) に従う",
  "4Regzm": "加盟店リスト",
  "i6kDf/":
    "選択したデバイスには {num} 個の Nubis Free バージョンが含まれており、デバイス コマンドは使用できません。",
  o8tJYm: "デバイスコマンド",
  "+74JfZ": "例: Device_000001_Gaoqiao Merchant_Android",
  "+CLSks": "2. この命名規則が適用されるデバイス システム タイプ",
  "+GQdfc": "トークンを更新",
  "+m8vFq": "命名規則の詳細",
  "0KH9Qi": "デバイス システム タイプ",
  "0Z908D": "同じアプリケーションのバージョンは 1 つだけ選択できます",
  "0bBO2n": "バージョン",
  "0iTEVO": "トークンの表示",
  "12LEcf": "この命名規則 ({name}) を無効にしてもよろしいですか?",
  "1PtjRr": "デバイス名",
  "2/LdaO": "構成情報を保存する",
  "2V19bd": "設定ファイルの詳細",
  "2jlHQB": "2. 会社のデフォルトの命名規則",
  "3ZtPM3":
    "ストアが命名規則を設定していない場合、新しいデバイスを追加するときに会社の命名規則が適用されます。適用したくない場合は、次の規則を無効にすることができます。",
  "3qgucc": "タイムゾーンを手動で設定する",
  "5FboZ/": "タイプ",
  "5ZgUEM": "構成テンプレートを編集",
  "5d3yZi": "有効時間",
  "5noX9X": "設定ファイル名",
  "6Ty5/G": "正常に公開されました",
  "7NmXNy": "現在の番組情報",
  "7PkBL6": "サイレント アップデートを有効にする",
  "7ip592": "1. ネーミングルール名",
  "88CuCZ":
    "3. このストアに登録されているデバイスの命名方法を作成します (デバイス名が自動的に入力されます)",
  "8WYGi+": "コピーしてもよろしいですか?",
  "8huAxo": "新しいルールを追加",
  "8pB1C7": "アプリケーションを追加",
  "8u3CYe": "ネーミングルール名",
  "8zQ4So": "パッケージ ID:",
  "96c3gX": "フォーマット",
  "9iKk2b": "開始番号",
  AFZDo7: "インストール履歴",
  B0WqD0: "1. デバイス更新期間 (現地時間)",
  BqUpjt: "com.android.chrome などのパッケージ名を入力してください",
  "CM76+/":
    "このテンプレート ({name}) を有効にしてもよろしいですか? 有効にすると、デバイスはこのテンプレートを参照できるようになります。",
  CPTAAj: "自然数増加",
  CqlH6G: "ストアリストを適用",
  "D/Yid+": "有効にするかどうか",
  D2KnIQ: "ストアの関連付けが成功しました",
  DpnauN: "時間",
  Fi4xFb: "Android アプリケーションを正常にアップロードしました",
  G9APSK: "命名規則を編集",
  GRfLaO: "アプリケーション名",
  HDYjnT:
    "現在選択されているアプリケーションのバージョンは既存のアプリケーションよりも低いため、アプリケーションのインストールが失敗する可能性があります。アプリケーションが正しく選択されているかどうかを確認してください。それよりも低いバージョンのアプリケーションをインストールする必要がある場合は、以下を確認してください。元のプログラムを削除してからインストールしてください。",
  HOHQFs: "命名規則名を空にすることはできません",
  "HdxQ2/": "ストア関連の設定ファイルと命名規則",
  "I/k8FH": "リリース",
  IyhhzI: "設定ファイルを作成します",
  Kj5TRg: "インストールするデバイスの数",
  "L4w/Vo": "最新バージョン",
  MI3yI1: "{percentCompleted}% をアップロード中",
  MRe8Q9: "バージョン番号:",
  NrEurQ: "アップロードMbps",
  Nrx60r: "ダウンロード Mbps",
  OCp4OD: "設定ファイルを表示",
  PDFXBi: "今すぐ公開",
  PkLYZS: "デバイスの命名規則",
  PlNIQ9: "システム設定",
  "Q+0CDu": "命名規則を追加",
  Q5vbU5: "パッケージ ID が一致していません",
  QpOtgZ: "店舗名",
  R9TpN6: "推定インストール時間",
  RY4VVr: "アップローダー",
  RyXQqJ: "アップロード時間",
  UfxykZ: "理由",
  Unr58u: "更新時間",
  Uzdb6l: "デバイスの種類:",
  Vd3wZV: "全体",
  VqEr9u: "店舗数を適用",
  WdyIyo: "操作時間",
  WfS4rv: "オペレーター:",
  "XLdI1+": "Wi-Fi 強度",
  XnimdQ: "Windows",
  Ym4SPE: "リリース時間(デバイス実行時間)を選択",
  ZWN1C0: "この命名規則 ({name}) を有効にしてもよろしいですか?",
  ZdO12B: "ストアを適用",
  ZtZ7Yw: "プログラム名",
  aHlr3k: "削除",
  akvGrq: "構成ルール",
  aqQg0p: "エリア",
  bMdSkq: "ネットワーク速度テスト記録",
  batMBC: "テンプレート ({name}) を削除してもよろしいですか?",
  bsjenW: "命名規則を有効にする",
  cX08hK: "データが選択されていません",
  cawvIS: "最終更新時刻",
  cijnrq: "デバイスがインストールされました",
  d8xSfX: "バージョンコード",
  dGBGbt: "すべて",
  dRYBRc: "バージョン番号: {version}",
  "devicesList@1": "すべてのデバイスを選択",
  "devicesList@2": "すべてのデバイスを選択",
  eUNh5K: "インストールするデバイス",
  "ecTX+c": "プログラム名は必須です",
  eeCxuz: "OS の種類",
  epaa3H: "命名規則を追加",
  evJP5c: "命名規則",
  fX0dsH: "バージョン:",
  "fje/m/": "テンプレート名:",
  fq3WGG: "設定ファイル管理",
  gQ7kPU: "アンドロイド",
  gnNjS5: "個人のデバイス名",
  gyHdsW: "構成テンプレート",
  "gyh+d1": "ケーブル ネットワーク",
  hDmGQl: "バージョンコードを確認するかどうか",
  hqGPDw: "24 時間形式を有効にする",
  hxy4wV: "解析中",
  i5JzAA: "ステータス:",
  i5MLJc: "最終更新時刻: {lastUpdate}",
  ie9Iom: "構成テンプレートを表示",
  ifAmoA: "設定ファイルのテンプレート",
  imhWD8: "アップロード設定",
  iroVTo: "会社設定",
  j2kqd8: "命名規則を削除",
  j3QWSE: "自然数増加の開始番号は正の整数のみです",
  jKzbw6: "設定を変更する",
  "jN5tO+": "バージョン コード: {versionCode}",
  "jhfb/7": "正常に保存されました",
  k7dy8j: "関連する設定ファイル",
  kH9MHe: "命名規則を無効にする",
  kkLQie: "関連ストア",
  "ksb/lB": "元の番組を削除するかどうか",
  l0mW6t: "最新の更新時刻",
  mRHwkp:
    "({name}) テンプレートを無効にしてもよろしいでにした後、デバイスはテンプレートを参照できなくなります。",
  "mYa6W/": "カスタムテキスト",
  "mml+gT": "アプリケーションを選択",
  mn0ceu: "重複した構成ルールがあります。調整してください。",
  n1yIyi: "インストール時間",
  nDwIwd: "公開済み",
  nLERtc: "Android アプリケーションを更新する",
  o9bMHL: "サイズ",
  oC6GBl: "Android アプリケーション",
  "oFt+cN": "ネットワーク速度テスト",
  ovdKZi: "デバイス番号をインストールできません",
  "p/3Nn5": "モバイルネットワーク",
  qS0aFJ: "アプリケーション管理",
  qUiH5y: "構成ルールを空にすることはできません",
  qjtl3b: "システムアップデートを有効にする",
  "qqwM/t": "設定ファイル",
  rdEPl7: "デバイスをインストールできません",
  rsAvN6: "プログラム名:",
  rw3uGa: "新しい構成テンプレート",
  "s+aIlP": "店舗名検索",
  saeFbf: "ファイル",
  t8R6VW: "パッケージ ID: {package}",
  tWcCoB: "スピードテスト日",
  twpxdo: "Android アプリケーションをアップロード",
  "u/NB+Y": "パッケージID",
  vDCwZ9: "ファイルをアップロード",
  vLW90z: "命名規則 ({name}) を削除してもよろしいですか?",
  vr5TVT: "入力してください",
  wiSRo9: "インストールされているデバイスの数",
  "xE1H+X": "設定",
  xdjVt1: "テンプレート名が入力されていません",
  xlNcvg: "最終更新日:",
  xrQzKh: "Chromeなどのアプリケーション名を入力してください",
  xwYDb8: "バージョンコード:",
  ydktLD: "区切り文字",
  zeMk2K: "ドラフト",
  zok1hp: "Cスロット",
  zrIs7T: "最終更新時刻",
  "a++4i0": "公開時間は 24 時間後である必要があります",
  "3JwoQQ":
    "アップロードに失敗したため、アプリケーションはそれを解析できません。",
  "9Fvzl9": "一括リリース",
  OiP4rW:
    "現在、ストアに関連付けられた構成ファイルがあります。確認してください。",
  b95U3r: "設定ファイルリスト",
  nJetAr: "サポートされていない形式です。",
  lPA1qT: "この構成は特定のデバイスのみを対象としています",
  oXfYag:
    "バージョン コードはすでに存在します。もう一度アップロードしてください。",
  "k+a7BC": "サイレント更新時間を実行します",
  "/k2Fs5": "コンフィギュレーションの命名規則",
  e2ys3T: "設定の詳細を保存",
  yy7EDI: "アップロード",
  "+cCXuw": "ファイルから画像を選択",
  "0cZQXI": "パッケージ ID で追加",
  "0xm1Zu": "キーの組み合わせをロック",
  "33bmiC": "親ディレクトリが存在しません",
  "4UcMA+": "Wi-Fi を追加",
  "4ia8sI": "機能制御",
  "4o167y": "カスタム テキストの長さは 30 を超えることはできません",
  "66awCH": "更新",
  "C+cw77": "壁紙設定",
  E6G3sr: "キオスクモード",
  "FQK+2G": "ファイル同期",
  FWlWJR: "店舗情報を見る",
  HI1PTY: "フォルダー パスを入力してください",
  HNavdr: "会社名",
  JPIKnb: "ホーム画面",
  MufYuw: "ロック画面",
  NPjnPZ: "明るさ",
  "Pdx/YD": "パスワード",
  Pg5mqb: "ランドスケープモード",
  QSjBm5: "ファイルが存在しません",
  UH1kCc: "追加",
  UduVZX: "ファイルを選択",
  Usn1oq: "ポートレートモード",
  "Ymq1/H": "デバイスフォルダー名",
  YzG9Iw: "ブラックリスト",
  ZK1d6f: "SSID",
  bGGvOS: "画像を選択",
  c8uKl6: "Wi-Fi",
  dZlNkV: "構成を追加",
  dmEBpU: "ファイル同期設定",
  foT1aq: "現在のアップロードの進行状況:",
  g5Pknn: "ファイル サイズが制限を超えています",
  gltp3e: "Windows の通知をオフにする",
  gweUAO: "USB インターフェースをロック",
  nxeBGd: "例:",
  o8HwKf: "ファイル名",
  rULuF3: "次のネットワーク接続のみを許可するかどうか",
  tIm58E: "停止",
  tR69qg: "Windows の表示言語",
  tnYpSo: "検出リクエストは正常に送信されました",
  xNeD5U: "キャンセルされました",
  xiwfUp: "音量",
  znna6r: "店舗情報",
  "+UT6Us": "ジンバブエ",
  "+cSl6d": "オランダ",
  "+vx0UI": "ソロモン諸島",
  "+vz4Gy": "シエラレオネ",
  "/1g/gd": "キリバス",
  "/EzG+0": "モントセラト",
  "/ZaEbq": "ハイチ",
  "07BMT/": "アルジェリア",
  "0E6+/f": "グアム",
  "14axoc": "フォークランド諸島",
  "1BFTBO": "キューバ",
  "1GLoiG": "ジョージア",
  "1Z3cpQ": "コートジボワール",
  "1qc1Bb": "ラトビア",
  "217kis": "ルワンダ",
  "2c/STs": "モルドバ",
  "3B2kCX": "フェロー諸島",
  "3Nlsp9": "スロバキア",
  "3a17nf": "クック諸島",
  "41lx/9": "アフガニスタン",
  "4KMP9f": "コンゴ",
  "4obEtL": "トーゴ",
  "5w+tOJ": "アルバニア",
  "62Z8c1": "パラオ",
  "6JR/Y7": "アイルランド",
  "6LZPqX": "サモア",
  "6Mnz8p": "モーリタニア",
  "6NPwCy": "シリア",
  "6f8kym": "イラク",
  "6qdPnx": "チュニジア",
  "7KZ6vz": "ベネズエラ",
  "7hGupC": "リトアニア",
  "7hNQVL": "フィリピン",
  "7p85Tc": "キュラソー",
  "8m5tda": "エジプト",
  "8y7qAE": "中央アフリカ共和国",
  "98qFTO": "ジャージー",
  "99fbLn": "ウルグアイ",
  "9T1JPo": "マルタ",
  AD5RPE: "赤道ギニア",
  AKnToQ: "チャド",
  "AO/9GT": "フィンランド",
  AYs4yh: "マダガスカル",
  Ai6HyC: "ウガンダ",
  AksTq6: "アンティグア・バーブーダ",
  ArbweL: "ヨルダン",
  AzRGCX: "ドイツ",
  "B/oRh5": "ミクロネシア連邦",
  BcJbbP: "カタール",
  Bm5GdP: "台湾",
  MRbe2A: "台湾",
  BwMY6I: "西サハラ",
  BxT2qw: "トケラウ",
  C0YR5J: "トルクメニスタン",
  C2pikc: "南スーダン",
  C7RUR5: "ナウル",
  CKu8W1: "ニウエ",
  CYSGlA: "エストニア",
  "D/Hl19": "マルティニーク",
  DPthJ5: "ルクセンブルク",
  Dxf50E: "コモロ",
  EMaGPN: "ソマリア",
  "Eihfz+": "パキスタン",
  Eul4yJ: "イタリア",
  F0BTvX: "レユニオン",
  FsQ2Ph: "北マリアナ諸島",
  FzXhJn: "バチカン市国",
  GRDGdf: "ニューカレドニア",
  "HF/NiY": "アルメニア",
  HN9EHr: "韓国",
  HTqMY5: "ルーマニア",
  HZs8KL: "ブルキナファソ",
  I2RkrK: "カンボジア",
  I7Erl3: "モロッコ",
  IGBRed: "アゼルバイジャン",
  IPfyBg: "イラン",
  IbG9YJ: "ノーフォーク島",
  "IrME/4": "マカオ",
  XeQT0P: "マカオ",
  J1oSvz: "米領バージン諸島",
  JIPBj1: "ジャマイカ",
  JIWrkV: "カナダ",
  JJhl02: "コンゴ民主共和国",
  JOJTuh: "コスタリカ",
  JddSbX: "ドミニカ",
  L7PjzJ: "クリスマス島",
  LShUE0: "ブータン",
  "Le+IiI": "北マケドニア",
  LeMbDw: "ザンビア",
  LfkgD6: "オーストラリア",
  Lszars: "アメリカ合衆国",
  M16xFB: "ブルネイ",
  MMzrYK: "リヒテンシュタイン",
  MTVChl: "トンガ",
  MXueJK: "アンドラ",
  MYneOz: "ジブチ",
  MZwu6r: "ハード島とマクドナルド諸島",
  MbV1M9: "マレーシア",
  MkBrsn: "パラグアイ",
  MwNlM3: "ブルンジ",
  MyB1Vf: "サウジアラビア",
  NcwUGt: "イスラエル",
  OZFYbQ: "バヌアツ",
  OZyB9b: "ボスニア・ヘルツェゴビナ",
  Oc4oig: "ボリビア",
  OhEAqA: "ギリシャ",
  Oql6Jb: "ポルトガル",
  PB00mS: "ウォリス・フツナ",
  PBGuz3: "ポーランド",
  PIBLYF: "香港",
  "1ObLsW": "香港",
  PIHPBR: "サン・マルタン（フランス領）",
  PjOc8o: "ベラルーシ",
  "Q+FGAs": "アイスランド",
  "Q5QY0+": "ケイマン諸島",
  Q5U8nY: "アメリカ領サモア",
  QA9U89: "英領インド洋地域",
  QRUdeg: "メキシコ",
  QxRaqi: "デンマーク",
  RfQSLo: "北朝鮮",
  RlB4rB: "サウスジョージア・サウスサンドウィッチ諸島",
  RsWzOr: "ハンガリー",
  RzKiE0: "プエルトリコ",
  SEJjjI: "南極",
  SLmrMX: "ブルガリア",
  T6qzNm: "ラオス",
  Tb6AtC: "アラブ首長国連邦",
  To4yI6: "ガンビア",
  TqXGpl: "ベリーズ",
  UQHsPm: "カーボベルデ",
  UZmEHG: "モンゴル",
  Ulf4Sq: "インド",
  VCRq6v: "ピトケアン諸島",
  VIFtwp: "カメルーン",
  VTEHKS: "ギニアビサウ",
  VWg1hF: "スバールバル諸島およびヤンマイエン島",
  VhGXkw: "オーランド諸島",
  W2fcGi: "スリナム",
  W9gKgU: "セーシェル",
  WAl9tj: "東ティモール",
  "WH+mo5": "ウズベキスタン",
  WJAfY4: "ツバル",
  WobBPP: "リベリア",
  XfoqmV: "エルサルバドル",
  XoOuKT: "カザフスタン",
  YINkHp: "セルビア",
  YMjT8q: "シンガポール",
  "Z+fptr": "コロンビア",
  ZHe4St: "インドネシア",
  ZRhaI4: "バルバドス",
  ZgLO7j: "レバノン",
  a9nZYf: "ブーベ島",
  aNVBIV: "フランス",
  afgUkt: "トリニダード・トバゴ",
  ahaefV: "中国",
  b8Yur0: "ベナン",
  bCl9eg: "ベトナム",
  bKHwtk: "バングラデシュ",
  bQkGVT: "ロシア連邦",
  "cio5m/": "ニュージーランド",
  "d+SgS7": "ニカラグア",
  d97FOT: "パプアニューギニア",
  dUeWgE: "フィジー",
  dXFo2O: "ノルウェー",
  dcfcTW: "サンピエール島・ミクロン島",
  dyBAW0: "セネガル",
  eNa9WG: "セントヘレナ",
  eX9WT0: "サンマリノ",
  eiecNW: "レソト",
  eu7j6G: "モンテネグロ",
  f6i4Ch: "ドミニカ共和国",
  fSGNZz: "ベルギー",
  fe4fox: "スーダン",
  fp4MWN: "日本",
  g44w8D: "イギリス",
  gIZauu: "グアテマラ",
  gb8v87: "トルコ",
  h70zPD: "スペイン",
  hB6jsF: "キプロス",
  hBpMeF: "マーシャル諸島",
  hC0etv: "チリ",
  hLeEYi: "セントビンセントおよびグレナディーン諸島",
  hrmyDn: "タンザニア",
  htLGF6: "ボネール島",
  htNRZG: "モナコ",
  hy4yn7: "キルギス",
  iJsE6u: "マリ",
  iVyVIA: "ガーンジー",
  iYdC7o: "ネパール",
  icfTwL: "スリランカ",
  icoYQF: "フランス領南方・南極地域",
  ipoOkJ: "ニジェール",
  j2GbDK: "サントメ・プリンシペ",
  "j83TV+": "マン島",
  jHmcI7: "ギニア",
  jKdq05: "アルバ",
  "jZLo+u": "イエメン",
  kCwSgm: "スウェーデン",
  lAVHXj: "ガボン",
  lc0eVA: "サン・バルテルミー",
  ljBSDy: "バーレーン",
  mIgnTu: "バミューダ",
  mdbt1h: "グレナダ",
  n1eYYR: "クロアチア",
  n6sdJi: "ナイジェリア",
  nU0AoJ: "モーリシャス",
  nbVGOe: "ガイアナ",
  ncprFv: "パレスチナ",
  nfMTZ9: "リビア",
  "oC/YmL": "アンゴラ",
  oJA0AV: "ウクライナ",
  ofe1Jv: "スロベニア",
  ox0SUk: "エリトリア",
  pG9dnN: "フランス領ギアナ",
  pGsPfz: "タジキスタン",
  "prG89+": "シント・マールテン",
  "qKL/I7": "エクアドル",
  qhRoDt: "チェコ",
  r0r576: "オーストリア",
  riK5Od: "マヨット",
  "s/ZbGB": "ジブラルタル",
  sVaevR: "フランス領ポリネシア",
  sgg3ZA: "ケニア",
  srKhxN: "バハマ",
  ssKHGM: "グリーンランド",
  swmjZg: "タイ",
  "tUisY+": "ガーナ",
  u3ws3s: "南アフリカ",
  u9cEKj: "セントクリストファー・ネイビス",
  uPO36O: "ミャンマー",
  uY8iM9: "モザンビーク",
  ufZlit: "パナマ",
  ufyzs9: "セントルシア",
  v8IwQb: "アルゼンチン",
  vPS1uD: "ペルー",
  vTEjni: "マラウイ",
  vcSBZu: "ブラジル",
  vixhhG: "モルディブ",
  "wL/u2o": "タークス・カイコス諸島",
  "wYCJ++": "エスワティニ",
  "we/YPm": "オマーン",
  xFrFSm: "ナミビア",
  xV0lln: "イギリス領バージン諸島",
  xepQSL: "ココス諸島",
  xk4ByO: "グアドループ",
  xwICWz: "スイス",
  yC4n0v: "クウェート",
  yKWAek: "アンギラ",
  yLlbwi: "ボツワナ",
  zhs13i: "ホンジュラス",
  zw39MM: "エチオピア",
  "+31PFz": "アジア/ウルムチ",
  "+6yBji": "アジア/バンコク",
  "+CgfU2": "太平洋/エファテ",
  "+POdLR": "ヨーロッパ/ヴォルゴグラード",
  "+VqRkg": "アメリカ/ケンタッキー/モンティチェロ",
  "/+Dhy+": "アメリカ/サンパウロ",
  "/D9zXZ": "大西洋/レイキャビク",
  "/UGQnF": "アメリカ/ノーム",
  "0DYv/B": "アフリカ/ナイロビ",
  "0HnaGc": "太平洋/クェゼリン",
  "0R8CQs": "ヨーロッパ/ブダペスト",
  "0xV9JO": "アメリカ/アルゼンチン/ラリオハ",
  "1H4FmE": "ヨーロッパ/ウジホロド",
  "1mv3LM": "アジア/チタ",
  "1pl9Su": "アフリカ/トリポリ",
  "1sEPCz": "アジア/東京",
  "1ua619": "ヨーロッパ/プラハ",
  "23aBJh": "アメリカ/デンバー",
  "2DXZtH": "ヨーロッパ/コペンハーゲン",
  "2OWj6s": "アジア/ベイルート",
  "2WXSh8": "アジア/カラチ",
  "2qYhi8": "アジア/香港",
  "2s/Mlc": "アジア/カムチャツカ",
  "2zQAXL": "ヨーロッパ/キシナウ",
  "327IN3": "アメリカ/ヤクタット",
  "339CIL": "アメリカ/ベリーズ",
  "3Lz3cq": "太平洋/エンダーベリー",
  "40b51E": "アメリカ/ミクロン",
  "4AZ4gQ": "アメリカ/アルゼンチン/サルタ",
  "4D94K+": "南極/ケーシー",
  "4NXksL": "ヨーロッパ/リスボン",
  "4XF+Io": "アメリカ/テグシガルパ",
  "4l3qM7": "太平洋/ヌメア",
  "4neOsl": "アメリカ/デンマークシャウン",
  "4wb1r/": "ヨーロッパ/ルクセンブルク",
  "5M8Wkq": "アメリカ/アルゼンチン/フフイ",
  "5oeyFi": "アメリカ/アルゼンチン/リオガジェゴス",
  "5xwaJJ": "太平洋/フナフティ",
  "6/dk2l": "ヨーロッパ/シンフェロポリ",
  "6Rz5js": "アフリカ/アイウン",
  "6XgRmz": "アジア/ホブド",
  "6d5tvh": "アメリカ/ボアビスタ",
  "6wYqzG": "太平洋/ウェーク",
  "71fHGN": "アメリカ/ガイアナ",
  "7Q7WxK": "アメリカ/グアテマラ",
  "7WBtG1": "太平洋/マジュロ",
  "7euHXg": "太平洋/ブーゲンビル",
  "7jiQ+M": "アジア/台北",
  "82GEmf": "太平洋/ナウル",
  "8DjTJi": "太平洋/ファカオフォ",
  "9Fhwtp": "アフリカ/モンロビア",
  "9TfEAv": "アジア/ダッカ",
  "9UC6g0": "アジア/マカオ",
  "9xN38t": "アジア/リヤド",
  A1qgI0: "アメリカ/カンポグランデ",
  A8Tpo2: "アフリカ/カイロ",
  ADtcg9: "アメリカ/インディアナ/ピーターズバーグ",
  AQnn4z: "アジア/カタール",
  AX2M6K: "アフリカ/カサブランカ",
  ApEhaf: "南極/ボストーク",
  "BsRS+L": "アフリカ/ラゴス",
  "CIpc+3": "アジア/ヤンゴン",
  CJgAlM: "アメリカ/アルゼンチン/ブエノスアイレス",
  CMi686: "ヨーロッパ/サマラ",
  CRI2Ve: "太平洋/チャタム",
  CezJKN: "アメリカ/サンティアゴ",
  "Cs/zIo": "太平洋/マルキーズ",
  CvKLCn: "太平洋/トンガタプ",
  CwyqPj: "アフリカ/アクラ",
  D1tmTQ: "アメリカ/ノースダコタ/センター",
  D55vg4: "アフリカ/チュニス",
  DAlYN5: "ヨーロッパ/イスタンブール",
  DCrzIX: "ヨーロッパ/アンドラ",
  DDqHds: "アフリカ/ハルツーム",
  DQsykN: "アメリカ/ハバナ",
  DVZRDC: "ヨーロッパ/オスロ",
  DcYI27: "アフリカ/マプト",
  "EGDZo+": "アジア/スレドネコリムスク",
  EcRGq9: "アジア/ドバイ",
  EgIxeE: "アメリカ/ジャマイカ",
  "EnTK+r": "アメリカ/シカゴ",
  EqvKbF: "アメリカ/クイアバ",
  F0y8e9: "アメリカ/ロサンゼルス",
  F465cE: "ヨーロッパ/ヘルシンキ",
  F6OWRn: "太平洋/ポートモレスビー",
  FDGDXD: "ヨーロッパ/キエフ",
  FEnpn4: "ヨーロッパ/ベルリン",
  FeFqOa: "アジア/チョイバルサン",
  "G0/1QH": "アメリカ/パラマリボ",
  "GHrEk+": "アジア/ホーチミン",
  Gcuin4: "アジア/ウランバートル",
  "H+kwCw": "アジア/ブルネイ",
  "H/TECz": "アジア/ソウル",
  H11GhT: "アジア/カンディガ",
  HD7dNh: "アジア/キジロルダ",
  HDlqGj: "アメリカ/アルゼンチン/トゥクマン",
  HSmzBV: "アメリカ/アルゼンチン/サンルイス",
  I2fe6r: "アジア/ヘブロン",
  ID5HGa: "太平洋/グアム",
  "IRsI+H": "アジア/マカッサル",
  IVs8gT: "インド洋/モーリシャス",
  "IYKKU/": "アジア/エレバン",
  IYSP57: "アメリカ/サンタレン",
  JGg252: "アジア/ディリ",
  "JJJ+wW": "太平洋/ウォリス",
  JTTFhT: "太平洋/コスラエ",
  KBQ98i: "ヨーロッパ/ソフィア",
  L6RwvT: "アメリカ/スコアズビースンド",
  LFkBwb: "アジア/クアラルンプール",
  LGJGKo: "アメリカ/インディアナ/ウィナマック",
  LepYst: "アメリカ/アルゼンチン/サンフアン",
  LrC3cb: "アフリカ/ヨハネスブルグ",
  M74J18: "太平洋/アピア",
  "MS/dmQ": "ヨーロッパ/ビリニュス",
  MYvQtB: "太平洋/ポンペイ",
  MhFcna: "アジア/アクタウ",
  MpIqyW: "アジア/ノボシビルスク",
  "N69J/J": "アメリカ/ケイマン",
  N7RBEQ: "ヨーロッパ/パリ",
  "NLL9E/": "アジア/シンガポール",
  Nap8NB: "アメリカ/ラパス",
  NhLpaB: "アジア/ガザ",
  NwiC8y: "アジア/バクー",
  OPz5aV: "ヨーロッパ/ワルシャワ",
  "OSP/DU": "アメリカ/アラグアイナ",
  "OoH/k4": "ヨーロッパ/マルタ",
  OqlGXK: "大西洋/フェロー",
  OtFyGC: "ヨーロッパ/ザポロジェ",
  P9EyMh: "アジア/アルマトイ",
  PRo9ZX: "アメリカ/グランドターク",
  Pbr43k: "太平洋/ガンビエ",
  PdnZvE: "アメリカ/インディアナ/ノックス",
  Phhnuu: "太平洋/ガダルカナル",
  "PlA+93": "アメリカ/アンカレッジ",
  "Q+QFi7": "アメリカ/パナマ",
  Q0Nwql: "アメリカ/ナッソー",
  Q2hC7E: "アジア/アナディリ",
  RTFf0R: "アジア/タシュケント",
  RVtTvI: "アメリカ/ボゴタ",
  RcUwWS: "ヨーロッパ/ティラナ",
  Rfu8ru: "アメリカ/ジュノー",
  RzRPhx: "アジア/テヘラン",
  SRDvbw: "インド洋/クリスマス",
  SkSGFq: "アメリカ/アスンシオン",
  SqYr66: "太平洋/チューク",
  T7X3nR: "アメリカ/コスタリカ",
  TnMEvg: "ヨーロッパ/リガ",
  TnQgWT: "インド洋/ココス",
  UE61nU: "アジア/ジャカルタ",
  UEbt0M: "ヨーロッパ/アテネ",
  UjOTtz: "ヨーロッパ/モナコ",
  VlcnXa: "大西洋/アゾレス",
  WICb5K: "アジア/マガダン",
  "WJ+FQF": "アジア/トビリシ",
  WTSjw5: "太平洋/パゴパゴ",
  WUi6ng: "アジア/クチン",
  WX1P13: "南極/デービス",
  Wb2LCw: "南極/ロセラ",
  Wg0kce: "アメリカ/インディアナ/ビンセンス",
  WhpVLY: "アメリカ/グアヤキル",
  Wq4Z0k: "アメリカ/ベレン",
  XK8hFK: "アメリカ/リオブランコ",
  XLgiC3: "太平洋/ノーフォーク",
  XN4sjj: "アジア/サマルカンド",
  XuXXK5: "アメリカ/レシフェ",
  YOJC0Y: "アメリカ/インディアナ/マレンゴ",
  Yux40Y: "南極/パーマー",
  "Z+d4VE": "ヨーロッパ/アムステルダム",
  ZOXOj5: "南極/モーソン",
  "aKg/xg": "南極/トロール",
  "aqHEW/": "アフリカ/アルジェ",
  aqZ1dw: "太平洋/ガラパゴス",
  aylTTV: "アメリカ/キュラソー",
  "b5+eh2": "アジア/バグダッド",
  b5GT3E: "アフリカ/ビサウ",
  bf8oMi: "太平洋/クリスマス",
  bkKBAQ: "アジア/ポンティアナック",
  c5lOtj: "アジア/ウラジオストク",
  cCvy0S: "アメリカ/カラカス",
  ciyA6X: "アジア/マニラ",
  cl18LV: "アジア/ウストネラ",
  d6W7pe: "ヨーロッパ/モスクワ",
  dw9A9j: "アメリカ/アルゼンチン/メンドーサ",
  e77Cv2: "アジア/ヤクーツク",
  e88zL2: "アジア/ニコシア",
  eDz3Tw: "アメリカ/アダック",
  eJqVsD: "ヨーロッパ/ジブラルタル",
  "eR7v+R": "アメリカ/ノースダコタ/ビューラ",
  ekhdTj: "アジア/ジャヤプラ",
  "f6G4/S": "太平洋/オークランド",
  f6r66H: "アメリカ/メノミニー",
  fJpD6E: "アフリカ/ンジャメナ",
  fqXfBN: "ヨーロッパ/ローマ",
  "fxAR+x": "アジア/オラル",
  g2HLMh: "南極/ショウワ",
  gU3Odo: "アメリカ/ニューヨーク",
  "gibo/e": "ヨーロッパ/ウィーン",
  gln1VX: "アメリカ/エルサルバドル",
  guiUEK: "ヨーロッパ/ブカレスト",
  gycX1L: "アメリカ/ノローニャ",
  h5YZ1i: "ヨーロッパ/ブリュッセル",
  hI5EVU: "インド洋/レユニオン",
  hKq7PN: "ヨーロッパ/カリーニングラード",
  hL3apR: "アメリカ/リマ",
  hZiOxa: "アメリカ/プエルトリコ",
  hdgzx5: "太平洋/イースター",
  hrq9xi: "ヨーロッパ/ミンスク",
  iBXv4d: "アメリカ/メトラカトラ",
  inPmEU: "ヨーロッパ/タリン",
  jRwF7m: "アメリカ/フェニックス",
  jaNloj: "アメリカ/マセイオ",
  jtTALf: "太平洋/ホノルル",
  k6R7DN: "アメリカ/フォルタレザ",
  kLf0tS: "アメリカ/デトロイト",
  lAz3SQ: "アジア/ビシュケク",
  lNijTx: "大西洋/スタンリー",
  m5vKwe: "アジア/コルカタ",
  mXs7zw: "アメリカ/シトカ",
  mnvAEu: "アメリカ/インディアナ/テルシティ",
  n8UW9y: "アジア/エカテリンブルク",
  nYFNxR: "アジア/サハリン",
  o5Rywj: "アメリカ/アルゼンチン/カタマルカ",
  oYmVJJ: "アジア/クラスノヤルスク",
  ocqIaV: "インド洋/チャゴス",
  ocqwXs: "アジア/オムスク",
  okHgMB: "アジア/ドゥシャンベ",
  pKp9LP: "アメリカ/インディアナ/ヴィーヴェイ",
  pNrCwc: "アメリカ/マナウス",
  pQ5zcx: "アメリカ/アルゼンチン/ウシュアイア",
  pcGYLU: "アメリカ/トゥーレ",
  pvDJax: "アメリカ/バルバドス",
  "q5++81": "ヨーロッパ/ロンドン",
  q7mJWt: "アメリカ/ボイシ",
  "qSxe/X": "ヨーロッパ/チューリッヒ",
  rB9Ewl: "アジア/アクトベ",
  rIY0ZR: "インド洋/モルディブ",
  rZTr8Y: "アメリカ/インディアナ/インディアナポリス",
  rhN321: "アメリカ/ヌーク",
  rslOL6: "太平洋/タラワ",
  rwZktH: "アメリカ/アルゼンチン/コルドバ",
  s2obSj: "太平洋/パラオ",
  s3GZlv: "アメリカ/ポートオブスペイン",
  slYOe6: "アメリカ/カイエンヌ",
  szkWWk: "アメリカ/バイーア",
  t5CPbZ: "ヨーロッパ/ダブリン",
  tHE78L: "アメリカ/サントドミンゴ",
  tMDDnr: "アメリカ/マナグア",
  tUaF1F: "太平洋/ニウエ",
  tlkIG3: "太平洋/フィジー",
  "tw/bjJ": "アジア/ノヴォクズネツク",
  u0TM9W: "アメリカ/ポルトープランス",
  uMXTTe: "ヨーロッパ/ストックホルム",
  uNiOLq: "アジア/エルサレム",
  "uOkO/r": "アジア/イルクーツク",
  "utbU0+": "アジア/アシガバート",
  ux1XM2: "大西洋/バミューダ",
  "v+arTX": "アメリカ/エイルネペ",
  vMATTy: "アジア/ダマスカス",
  "vWWiU+": "アジア/平壌",
  vbHpIo: "アフリカ/ウィントフック",
  vn9nKr: "アメリカ/ポルトヴェーリョ",
  vohVUs: "アジア/カブール",
  vwtvCc: "大西洋/カーボベルデ",
  vy4zY8: "アジア/コロンボ",
  w7kHCL: "大西洋/マデイラ",
  wDFHDz: "アメリカ/マルティニーク",
  "wbQai/": "大西洋/サウスジョージア",
  wrZg4b: "アジア/ティンプ",
  xAcBeP: "太平洋/タヒチ",
  xKA8d6: "南極/デュモンデュルビル",
  "xx+5iB": "アメリカ/ケンタッキー/ルイビル",
  y79PlA: "アジア/アンマン",
  yaBGO1: "太平洋/ピトケアン",
  yeltlL: "インド洋/マエ",
  ygabsP: "アメリカ/ノースダコタ/ニューセーラム",
  z6KEn9: "太平洋/ラロトンガ",
  z98zna: "インド洋/ケルゲレン",
  zWABd8: "ヨーロッパ/ベオグラード",
  zm3ZI2: "アジア/上海",
  zwjmMl: "アジア/カトマンズ",
  "e5x+i6": "オーストラリア/ロード・ハウ",
  gAtxKw: "南極/マッコーリー",
  P5aTR8: "オーストラリア/ホバート",
  "nFhe/c": "オーストラリア/カリー",
  e6YJm8: "オーストラリア/メルボルン",
  dmcxmV: "オーストラリア/シドニー",
  jFnCUr: "オーストラリア/ブロークンヒル",
  i5MwAy: "オーストラリア/ブリスベン",
  WyjEwT: "オーストラリア/リンデマン",
  JuasJd: "オーストラリア/アデレード",
  co8c88: "オーストラリア/ダーウィン",
  qm4oIk: "オーストラリア/パース",
  "0LrMZs": "オーストラリア/ユークラ",
  "+E914Q": "フランス語（レユニオン）",
  "+FHEub": "中央アトラス・タマジグト語（アラビア文字）",
  "/AAqs8": "ポルトガル語（赤道ギニア）",
  "/BbMQN": "シンハラ語",
  "/NVZFV": "ポルトガル語（アンゴラ）",
  "/V7bTl": "フラ語（ラテン文字、ガンビア）",
  "/YFnxw": "サホ語",
  "/stiNv": "タイ語",
  "019rDM": "ポルトガル語（ポルトガル）",
  "01GXUP": "フラ語（ラテン文字、ギニア）",
  "0BWpf+": "日本語",
  "0CHkPh": "西フリジア語",
  "0D82eT": "クロアチア語（ボスニア・ヘルツェゴビナ）",
  "0fzUyn": "ポルトガル語",
  "0mDCSY": "スペイン語",
  "0rqbd/": "マルタ語",
  "160k/R": "ロシア語",
  "1BHQDP": "ベンガル語（インド）",
  "1F0Uz0": "アラビア語（イラク）",
  "1J25kd": "ボスニア語（スラブ語）",
  "1RqABh": "リトアニア語",
  "1dv927": "マレー語（ブルネイ）",
  "29JxAe": "英語（イギリス）",
  "2LBIWM": "イヌクティトゥット語",
  "2OXQzm": "デンマーク語",
  "2atqiI": "オロモ語",
  "2hRVBA": "セルビア語",
  "30RDW+": "アラビア語（カタール）",
  "3PyL86": "英語（フィリピン）",
  "3Rvul8": "チベット語（インド）",
  "3ijo+p": "オランダ語（スリナム）",
  "4+Zl7y": "スペイン語（エルサルバドル）",
  "4Od9+t": "セルビア語（スラブ語、ボスニア・ヘルツェゴビナ）",
  "4U3ZpB": "フランス語（ハイチ）",
  "4Xzh0/": "ポルトガル語（スイス）",
  "4eGD8c": "フラ語（ラテン文字、シエラレオネ）",
  "4fkP4F": "スペイン語（キューバ）",
  "4lbmZs": "スペイン語（フィリピン）",
  "4v0pnb": "ウェールズ語",
  "51lnU8": "ケルン語",
  "5KynFd": "チェコ語",
  "5cyBop": "英語（インド）",
  "5ff1Qr": "ツォンガ語",
  "5g+4ES": "韓国語（北朝鮮）",
  "5riLBC": "ソマリ語（ジブチ）",
  "5vu2sQ": "ウズベク語",
  "5xPlEp": "中国語（繁体字）",
  "62eqUV": "北ルリ語",
  "6AZb8G": "イヌクティトゥット語（教育課程）",
  "6G/CAW": "ベルギー語",
  "6am43/": "中央クルド語",
  "6ebNfH": "中国語（簡体字、香港特別行政区）",
  "6gtes0": "中央アトラス・タマジグト語",
  "6sur5u": "デンマーク語（グリーンランド）",
  "7Gt5UH": "サンスクリット語",
  "7k8oo8": "ドイツ語（オーストリア）",
  "7wLEyk": "マン島語",
  "7yHu97": "ラトビア語",
  "8MDM0L": "タミル語（スリランカ）",
  "8oEDHH": "フランス語（モロッコ）",
  "93yDUJ": "南サーミ語（ノルウェー）",
  "9cbhiA": "アラビア語（世界）",
  "9ftsGr": "英語（マレーシア）",
  "9ltErv": "ロマンシュ語",
  "9uEO2O": "アストゥリアス語",
  AAf440: "セソトサレボア語",
  ALhR5U: "ケチュア語（ペルー）",
  "AQfg7+": "フランス語（コンゴ民主共和国）",
  AahSYM: "ウズベク語（アラビア文字）",
  AeHTyT: "英語（香港特別行政区）",
  "B+59h1": "モンゴル語（伝統的モンゴル文字）",
  B8qZTI: "アルメニア語",
  B9ZGRE: "ラオ語",
  BFf5tN: "フランス語（カナダ）",
  BgGwdt: "ベトナム語",
  BpUgM5: "オランダ語（ボネール、シント・ユースタティウスおよびサバ）",
  BtqqJK: "スペイン語（ホンジュラス）",
  CBhHg6: "フラ語（ラテン文字、ナイジェリア）",
  CDbpEz: "アイスランド語",
  CFRfr5: "ゾンカ語",
  CauPny: "カタルーニャ語（フランス）",
  Ccf8zA: "スペイン語（ウルグアイ）",
  DBHTS0: "英語（オーストラリア）",
  DMjlMC: "ドイツ語（ベルギー）",
  DW0c2K: "スペイン語（チリ）",
  DzWKvp: "グルジア語",
  "EP6mL+": "マニプリ語",
  EREJay: "サーミ語（ルレ）",
  EeOqFb: "ポルトガル語（サントメ・プリンシペ）",
  EzFn0W: "オランダ語（アルバ）",
  F38yZH: "ソマリ語",
  "FHLC+T": "ドイツ語（リヒテンシュタイン）",
  Fxzz1N: "スウェーデン語（フィンランド）",
  FzgpJw: "ベンガル語",
  G7wzBO: "アラビア語（アラブ首長国連邦）",
  "GF/5qr": "タシェルヒート語",
  GGLJ5z: "コルシカ語",
  GHtHh4: "マオリ語",
  "GRMM/R": "アルザス語（フランス）",
  "GZ+vSv": "シリア語",
  GnC74O: "チベット語",
  GqQl0h: "イタリア語",
  GsOiFJ: "英語（南アフリカ）",
  Gwyv4n: "パンジャブ語",
  "H/OHWA": "フィリピノ語",
  H4fFDA: "北サーミ語",
  H73FDV: "ウイグル語",
  "H7jT/h": "アルバニア語（コソボ）",
  HDDkEc: "ズールー語",
  HVCuT9: "英語（ドイツ）",
  HZPa57: "スコットランド・ゲール語",
  "Hhe/Ef": "スペイン語（ブラジル）",
  Hj8GDj: "グジャラート語",
  Hq92CJ: "ハワイ語",
  HqCNsI: "ノルウェー語",
  "I/+zqv": "英語（ガーンジー）",
  I42yCw: "英語（カナダ）",
  IC7HXP: "ティグリニャ語",
  IDCrtf: "フィンランド語",
  IEUJ0j: "ドイツ語（ルクセンブルク）",
  "IR/BFt": "ソマリ語（エチオピア）",
  ItGyiB: "カンナダ語",
  Iz1WLp: "ウルドゥー語",
  J1rnrw: "スロベニア語",
  J5rPWm: "スペイン語（エクアドル）",
  JPFRXM: "英語（マルタ）",
  JVK3dg: "ドイツ語",
  JkretN: "英語（フィンランド）",
  Js4yYb: "フラ語",
  "Jsem/p": "モホーク語",
  KDsjWJ: "標準モロッコ・タマジグト語",
  "Kj/zcq": "フランス語（モナコ）",
  LX0RZR: "フラ語（アドラム文字）",
  Laghvq: "キニヤルワンダ語",
  Ll0N3I: "チェロキー語",
  MESBkg: "コサ語",
  MJQbru: "バシキール語",
  Mbp9v6: "アラビア語（シリア）",
  Mt9Ngn: "ヘブライ語",
  N4oAho: "ソト語",
  NLZIcM: "オランダ語（ベルギー）",
  NObQUE: "アフリカーンス語",
  "NV+8r2": "マプチェ語",
  NVQG0j: "ディベヒ語",
  Nevbjx: "フラ語（ラテン文字、モーリタニア）",
  NfTD2i: "スペイン語（ベネズエラ）",
  NhbCYP: "バレンシア語（スペイン）",
  NtuQMz: "ポルトガル語（マカオ特別行政区）",
  "O/Bw0H": "セルビア語（ラテン文字、コソボ）",
  OKUlj2: "ハンガリー語",
  OSMagZ: "フランス語",
  Oju9iC: "モンゴル語",
  P23feN: "スペイン語（ベリーズ）",
  "P91ei/": "タジク語",
  PE6jNM: "スペイン語（アルゼンチン）",
  PO8fNg: "ポルトガル語（東ティモール）",
  POQTzM: "フランス語（セネガル）",
  PSoXmh: "オリヤー語",
  Pa7aMt: "アラビア語（レバノン）",
  Pl3tfG: "スウェーデン語",
  PsNb95: "アイルランド語",
  Q8eBZk: "オランダ語",
  QBwWZp: "オロモ語（ケニア）",
  Qcitp4: "ジャワ語",
  Ql51WU: "マラーティー語",
  R1VwTR: "バスク語",
  R325ks: "スペイン語（ラテンアメリカ）",
  R34HBa: "アラビア語（オマーン）",
  RRmxSU: "ケチュア語",
  RTbzBi: "上ソルブ語",
  RWrQ2K: "アラビア語（アルジェリア）",
  "RqsM+G": "スペイン語（ニカラグア）",
  SUF5bX: "英語（オーストリア）",
  Sg9DRE: "フランス語（スイス）",
  SlWjJ2: "南サーミ語",
  T9IHrN: "ルクセンブルク語",
  TQ7V9A: "アラビア語（モロッコ）",
  Tddnlb: "テルグ語",
  Tq0aui: "クメール語",
  UAHDtf: "マラヤーラム語",
  UGFi6Q: "アラビア語（ヨルダン）",
  Uc1vOK: "アルバニア語",
  "V+BaHn": "パシュトー語",
  V223G2: "フラ語（ラテン文字、ブルキナファソ）",
  V2uMRt: "タミル語",
  VJbQAt: "スペイン語（パナマ）",
  VKt1qn: "ネパール語（インド）",
  VuQRaN: "イタリア語（スイス）",
  W6zXNX: "スペイン語（ドミニカ共和国）",
  WK7YIm: "アラビア語（イエメン）",
  WQtbS0: "英語",
  WU7Urn: "トルコ語",
  WUUTG8: "トルクメン語",
  Wlr6BV: "カタルーニャ語（イタリア）",
  XAmFMw: "クロアチア語",
  XNXAkr: "ケチュア語（エクアドル）",
  XT8v2Z: "カタルーニャ語",
  XjbxJQ: "アフリカーンス語（ナミビア）",
  Xkmde4: "中国語（簡体字、マカオ特別行政区）",
  Xx527p: "北サーミ語（スウェーデン）",
  Y7CQhy: "スイスドイツ語",
  Y8mZTh: "英語（ジャマイカ）",
  Y941O5: "スロバキア語",
  YNjb1t: "フェロー語",
  Ygp3rn: "ボスニア語",
  "Z/MVyq": "教会スラヴ語",
  ZCh9e6: "下ソルブ語",
  ZQtURc: "ルーマニア語（モルドバ）",
  ZjrmiJ: "ショナ語",
  "Zki/XJ": "カザフ語",
  a9U6ge: "コーンウォール語",
  aO94Wj: "ウルドゥー語（インド）",
  "aTZE+x": "カシミール語（デーヴァナーガリー文字）",
  aiXFTk: "フラ語（ラテン文字、ガーナ）",
  bDNNJp: "マレー語（インドネシア）",
  bLqBa4: "英語（ニュージーランド）",
  bRIPjy: "英語（イスラエル）",
  "bT+IsS": "マレー語（シンガポール）",
  bVuD3F: "アラビア語",
  bfp8tQ: "グリーンランド語",
  c3rP5p: "英語（スロベニア）",
  cJbw13: "中国語（繁体字、台湾）",
  cQRIur: "英語（シンガポール）",
  d5MtIX: "インドネシア語",
  dEIOuD: "ポーランド語",
  dPzT2w: "ブルトン語",
  drEx3O: "スワヒリ語",
  e9Fovw: "パピアメント語",
  eGmwHh: "英語（スイス）",
  eSg76K: "英語（ジブラルタル）",
  eSmbEf: "アイルランド語（イギリス）",
  eWnJnC: "ヒンディー語",
  efy66J: "チェチェン語",
  "f+NB92": "スペイン語（ペルー）",
  "f/8iNS": "フラ語（ラテン文字、カメルーン）",
  "f5+iem": "スペイン語（メキシコ）",
  f6Viji: "パシュトー語（パキスタン）",
  fkHabQ: "キチェ語",
  fv9aDa: "サーミ語（イナリ）",
  "gHco+M": "ロシア語（モルドバ）",
  gOsLMk: "マダガスカル語",
  gWx9ey: "セルビア語（ラテン文字、モンテネグロ）",
  gfmlPE: "英語（アイルランド）",
  glnMAY: "タシェルヒート語（ラテン文字）",
  gvaI7A: "ソマリ語（ケニア）",
  "h6q+Tn": "プルシ語",
  h9YX8r: "タミル語（シンガポール）",
  "hEPDg/": "オック語",
  hNSwvJ: "フラ語（ラテン文字、リベリア）",
  hcX72z: "タミル語（マレーシア）",
  hmzrxz: "北サーミ語（フィンランド）",
  hr7Bt0: "ポルトガル語（ギニア）",
  i4jvwu: "中国語",
  "i5/TH8": "スペイン語（赤道ギニア）",
  "iI431+": "英語（オランダ）",
  iKxsEO: "ネパール語",
  iTiaM1: "グアラニー語",
  iXn58z: "アゼルバイジャン語（スラブ文字）",
  ifdXl3: "韓国語",
  jG6ZfL: "ドイツ語（イタリア）",
  jGXHMX: "セルビア語（ラテン文字 、ボスニア・ヘルツェゴビナ）",
  "jHvE/3": "ンコ語",
  joVZ4M: "アラビア語（エジプト）",
  "k+bU6l": "オランダ語（シント・マールテン）",
  k6RCbu: "ポルトガル語（ルクセンブルク）",
  kW1ixl: "スワヒリ語（ウガンダ）",
  l8f1rC: "カシミール語",
  lGAoQJ: "スワヒリ語（タンザニア）",
  "lig/ia": "ボド語",
  lwerC3: "スペイン語（アメリカ合衆国）",
  "m+zQs1": "イボ語",
  m421XM: "ウクライナ語",
  "mP+2ZR": "英語（トリニダード・トバゴ）",
  mQ30Fl: "英語（フォークランド諸島）",
  mQPNAb: "シンド語",
  mgFsmM: "英語（デンマーク）",
  "mkyn/R": "アラビア語（バーレーン）",
  mq4oU3: "英語（ジャージー）",
  mvxq4r: "ガリシア語",
  n86rIs: "キルギス語",
  naThLg: "ギリシャ語",
  ncJAOw: "ビルマ語",
  nfKkEe: "フラ語（ラテン文字、ニジェール）",
  nzfKPJ: "フランス語（カメルーン）",
  "oCgi+u": "アムハラ語",
  "oh7xe+": "サーミ語（ルレ、ノルウェー）",
  oiHWuC: "ドイツ語（スイス）",
  ono6Zw: "スペイン語（グアテマラ）",
  ouSGKF: "サーミ語（スコルト）",
  pJE11U: "セツワナ語（ボツワナ）",
  pVxDdM: "マザンダラーン語",
  pcWfuB: "セツワナ語",
  pdfcvu: "フランス語（コートジボワール）",
  pjF6Nn: "ソト語（レソト）",
  pqIrOS: "アラビア語（チュニジア）",
  q2N4yn: "セルビア語（スラブ語）",
  qQDW8M: "フランス語（マリ）",
  qRbMrx: "ヨルバ語",
  qYdUNv: "中央アトラス・タマジグト語（ティフィナグ文字）",
  qu9gJ5: "アラビア語（リビア）",
  qwSYAN: "ポルトガル語（モザンビーク）",
  r8ZWqf: "新ノルウェー語",
  rcixhA: "オランダ語（キュラソー）",
  rcmyN3: "ペルシア語（アフガニスタン）",
  rk5DA1: "英語（ベルギー）",
  sBC8AY: "シンド語（デーヴァナーガリー文字）",
  sHbxv8: "英語（ベリーズ）",
  sRuB7H: "マレー語",
  sl0qaQ: "アラビア語（クウェート）",
  sliV2n: "スペイン語（パラグアイ）",
  syMU2g: "フランス語（ベルギー）",
  tQJpug: "カタルーニャ語（サルデーニャ）",
  tQi27b: "コンカニ語",
  tRgqyZ: "セルビア語（スラブ語、コソボ）",
  tdrfAE: "英語（カリブ海）",
  u0KReQ: "イタリア語（バチカン市国）",
  u61cWR: "スペイン語（コロンビア）",
  u78bW4: "マケドニア語",
  uCI04p: "エストニア語",
  uVRPPZ: "タタール語",
  ubfX8q: "英語（ジンバブエ）",
  uh1OQN: "ウォロフ語",
  upv4s2: "ポルトガル語（カーボベルデ）",
  vSG3D5: "スペイン語（コスタリカ）",
  viRRMu: "セルビア語（スラブ語、モンテネグロ）",
  vo99Cy: "英語（ブルンジ）",
  vuf8EY: "英語（イギリス領ヴァージン諸島）",
  vxR1y4: "ハウサ語",
  wVqnrV: "ペルシア語",
  wra0CG: "スワヒリ語（コンゴ）",
  wtZRFn: "フリウリ語",
  x0KMJr: "英語（マン島）",
  xXkK79: "モンゴル語（伝統的モンゴル文字）",
  xeXtGt: "英語（スウェーデン）",
  xgB0JY: "アッサム語",
  xoMuR7: "ヴァルザー語",
  "xzWaZ/": "スペイン語（プエルトリコ）",
  "y//NHV": "アゼルバイジャン語",
  y7nOlh: "ブルガリア語",
  ydTOo2: "フランス語（ルクセンブルク）",
  z0tSbC: "オセット語",
  z1VBi8: "ルーマニア語",
  zBWf5p: "インターリングア",
  zWU1xI: "スペイン語（ボリビア）",
  "05KCjo": "アプリアイコン：",
  "11uVJ/": "オブジェクトを受信",
  "1Qoc6t": "プロセス名:",
  "2JW1Pt": "メールを同時に送信するかどうかを選択してください",
  "70JpVD": "プロセス名",
  "9AsSO/": "テキスト メッセージを同時に送信するかどうかを選択してください",
  "AH+jWQ": "Windows アプリケーション",
  Axagls: "終了時間を選択してください",
  FNIJXx: "スクロール再生を選択してください",
  Fir0oq: "通知の種類を選択してください",
  G4qgGm: "すべてのユーザー",
  G5gg2V: "アナウンスのタイトルは必須です",
  IWPf2S: "お知らせの詳細",
  IbWDVg: "バージョン番号が必要です",
  Km733q: "開始時間を選択してください",
  L24ioQ: "タイトル",
  L80hmc: "アナウンスのタイトルは 30 文字を超えてはなりません",
  NDjXUx: "ファイルをデプロイするコマンドを入力してください:",
  "Oex59+": "返されるリスト",
  QHc9Qg: "お知らせ内容",
  QNomO6: "バージョン番号を入力してください",
  Qpcx6F: "アナウンス内容は必須です",
  RQyKsa: "プラットフォームのお知らせ",
  TiK9WZ: "プロセス名は必須です",
  TvOGLc: "展開ファイルコマンド",
  UHuNzJ: "コマンドを入力してください",
  WtPk7v: "SMS を同時に送信",
  XbIN5K: "プログラム名を入力してください",
  XeIKK7: "通知センター",
  ZqioaF: "通知のタイトル",
  aGxRt2: "コンテンツ",
  cr1ymH: "送信時間を選択してください",
  dY3og7: "アプリのアップロードアイコン:",
  eFDqHN: "Windows アプリケーションを正常にアップロードしました",
  eSfTZf: "Windows アプリケーションをアップロード",
  "ghKe/+": "プロセス名",
  "h5yj+x": "プロセス名を入力してください",
  jAJbuk: "通知のお知らせ",
  l36W55: "スクロール再生",
  lqQKL4: "プロセス名で追加",
  mKKd1R: "受信者を選択してください",
  q9PHLT: "まだ発表はありません",
  wYygRu: "送信者",
  xXdMar: "指定されたユーザー",
  xx40g7: "お知らせのタイトル",
  yKFvYY: "メールを同時に送信",
  yfhtRM: "添付ファイル",
  z5L9EV: "Windows アプリケーションを更新します",
  "bhv+8O": "ダウンロード中",
  xzmRTb: "過去 7 日間の履歴のみを表示します",
  "yrR/HC": "インストール中",
  ibYzs0: "プログラム名: {name}",
  ivzCMK: "アプリケーションを解析できません。",
  mJBhe1: "ファイル同期では最大 10 個のファイルを追加できます",
  "6oXjFu": "アップロード形式が正しくありません",
  KetfTt: "最大画像サイズ: 500KB",
  baNBmh: "画像サイズは 500KB を超えることはできません",
  tAjFr2: "画像形式: PNG、JPG、JPEG、BMP、GIF、SVG、WEBP",
  "3K02K/": "Wi-Fi 構成が不完全です",
  "5Cm9U3": "メッセージ通知",
  "Y6Q+iJ": "Wi-Fi 設定を入力してください",
  tugHWJ: "お知らせリストに戻る",
  "x/FhNQ": "通知を表示",
  "+GRUnH": "アジア/ホブド",
  "+IL2pH": "アジア/リヤド",
  "+J2Dyk": "アメリカ/アスンシオン",
  "+Ny8AK": "アメリカ/プエルトリコ",
  "+RWig5": "スペイン語（ボリビア）",
  "/2Wzyw": "アメリカ/エルサルバドル",
  "/rG/9z": "アメリカ/キュラソー",
  "0AuprP": "太平洋/トンガタプ",
  "0X3KFO": "CPU温度",
  "0vIw5o": "アメリカ/ボゴタ",
  "1YfhFP": "アジア/ディリ",
  "2+A7qs": "南極/モーソン",
  "2+ec6P": "アメリカ/デンマークシャウン",
  "2FPNxz": "アジア/ドバイ",
  "32RJkL": "アメリカ/アルゼンチン/サンルイス",
  "33VS8L": "アメリカ/マセイオ",
  "36csPo": "ヨーロッパ/チューリッヒ",
  "3KlQfs": "オーストラリア/ブリスベン",
  "3LAnU7": "大西洋/フェロー",
  "3MaR6w": "ヨーロッパ/タリン",
  "3NE037": "アジア/アシガバート",
  "3svavz": "アメリカ/ミクロン",
  "42xSxy": "アジア/ノヴォシビルスク",
  "4LAo5S": "アメリカ/メトラカトラ",
  "4Sw/d9": "アジア/クラスノヤルスク",
  "4T/bEM": "アメリカ/インディアナ/ヴィーヴェイ",
  "4WaJo8": "アメリカ/スコレスビサン",
  "4Wgk5f": "ヨーロッパ/アンドラ",
  "4ZRHuu": "大西洋/サウスジョージア",
  "4cXOI/": "アジア/エレバン",
  "4jryq3": "アメリカ/ノースダコタ/ニューセーラム",
  "4sqSH4": "アジア/ハンディガ",
  "564gFy": "アフリカ/アクラ",
  "6SQvm5": "アジア/ポンティアナック",
  "6X6msx": "ストレージ使用状況",
  "6xnHrJ": "ヨーロッパ/ベルリン",
  "72KWoU": "オーストラリア/シドニー",
  "778/Xc": "アメリカ/テグシガルパ",
  "7JA1Vf": "アメリカ/アルゼンチン/メンドーサ",
  "7L+CJm": "ヨーロッパ/ヘルシンキ",
  "7geAkY": "アメリカ/アルゼンチン/ブエノスアイレス",
  "7teo40": "太平洋/チューク",
  "87d7yX": "太平洋/ガダルカナル",
  "8Gi8qJ": "オーストラリア/ブロークンヒル",
  "8eL/hC": "アジア/エルサレム",
  "8hJsOE": "アジア/バンコク",
  "8qYKWy": "太平洋/チャタム",
  "8woxjy": "アジア/クアラルンプール",
  "A3y/jB": "アメリカ/アルゼンチン/リオガジェゴス",
  ACHtOA: "アジア/カムチャツカ",
  AFZYEo: "アジア/ブルネイ",
  ALGNzc: "アジア/マガダン",
  AWhHY3: "アメリカ/リオブランコ",
  ApnLV0: "アジア/アルマトイ",
  AqKGKn: "アジア/ジャカルタ",
  As1lP0: "インド洋/ケルゲレン",
  "Aytpe/": "ヨーロッパ/モナコ",
  B6rikn: "アメリカ/インディアナ/インディアナポリス",
  B9NkmN: "ヨーロッパ/ルクセンブルク",
  BXdJNy: "大西洋/スタンリー",
  BgYCgo: "南極/ケーシー",
  C21hEn: "ヨーロッパ/ベオグラード",
  C7HjWu: "ヨーロッパ/アムステルダム",
  CBkGYl: "アフリカ/マプト",
  CC9Jw3: "アジア/マカッサル",
  CIImWq: "太平洋/マジュロ",
  "CNMmH/": "アジア/ヤクーツク",
  CR8w2m: "アメリカ/グランドターク",
  CUsFOe: "アメリカ/カイエンヌ",
  D2gXtv: "アメリカ/メノミニー",
  D4VBw5: "南極/デュモンデュルヴィル",
  DincSy: "オーストラリア/ロードハウ",
  DoPuye: "アジア/ダマスカス",
  "E/3oPZ": "アジア/マカオ",
  E2NUw6: "アフリカ/ヨハネスブルグ",
  EJA24j: "太平洋/ノーフォーク",
  EgGVTj: "太平洋/エンダーベリー",
  EhPWhM: "アメリカ/クイアバ",
  EmxcJt: "アメリカ/ヤクタット",
  Ewhh7n: "ヨーロッパ/ソフィア",
  FXD37C: "アメリカ/パナマ",
  FsXquv: "アジア/平壌",
  GIHcco: "アメリカ/ヌーク",
  GIwuGT: "ヨーロッパ/ブリュッセル",
  GNkv6K: "アフリカ/アイウン",
  "H8+X66": "アジア/カンディガ",
  HDVqMh: "アメリカ/アルゼンチン/サンフアン",
  HEpXP8: "アメリカ/デンバー",
  HOEyDX: "アメリカ/ラパス",
  HS4Jyv: "ヨーロッパ/ウジホロド",
  Hh1tUP: "アメリカ/グアヤキル",
  HkGIFU: "南極/デービス",
  HoSy6c: "太平洋/クェゼリン",
  HuSwkp: "アジア/ウスチネラ",
  HzSbcD: "南極/トロール",
  I3bX6d: "アジア/ウルムチ",
  IBZBgD: "ヨーロッパ/イスタンブール",
  IHXrCK: "アメリカ/ロサンゼルス",
  IKeroX: "アジア/ジャヤプラ",
  ILjenb: "アメリカ/インディアナ/マレンゴ",
  IgbKn9: "アジア/ホーチミン",
  InLlSF: "アメリカ/パラマリボ",
  J5iABC: "アジア/カラチ",
  JHjx5l: "アメリカ/アンカレッジ",
  "JURm/W": "南極/パーマー",
  "Jc5/LG": "アジア/オムスク",
  JrjIBq: "アメリカ/ポルトープランス",
  K9TF6H: "アジア/香港",
  KAKu2d: "太平洋/ヌメア",
  KEr7iI: "太平洋/パラオ",
  "KaS+yS": "アメリカ/コスタリカ",
  KyBesr: "太平洋/ラロトンガ",
  M3Bd2i: "太平洋/ピトケアン",
  MAVhWe: "ヨーロッパ/オスロ",
  MAWdwn: "アジア/コロンボ",
  McxhaP: "アメリカ/ベリーズ",
  MeSuny: "アメリカ/バルバドス",
  MmTr9O: "アフリカ/カイロ",
  Mr4JiU: "インド洋/チャゴス",
  MxWLCa: "太平洋/マルキーズ",
  NW4CG5: "アフリカ/トリポリ",
  NWpmvK: "ヨーロッパ/モスクワ",
  Nd0dlz: "アメリカ/アルゼンチン/カタマルカ",
  NhHERf: "アフリカ/ハルツーム",
  O2VzkZ: "ヨーロッパ/ジブラルタル",
  OEWR5m: "アメリカ/レシフェ",
  OPvCOV: "大西洋/レイキャビク",
  OdITFl: "インド洋/ココス",
  Oj7H2e: "ヨーロッパ/マルタ",
  OnT6Rq: "アメリカ/アルゼンチン/サルタ",
  P5ijks: "アジア/チタ",
  P8Gz8g: "アジア/サマルカンド",
  P8fuMA: "太平洋/アピア",
  PE4Jv1: "ヨーロッパ/カリーニングラード",
  "PHe5b/": "アメリカ/サンパウロ",
  PQTASm: "アフリカ/ナイロビ",
  PSTE5v: "アジア/テヘラン",
  "Pr/HJJ": "アメリカ/トゥーレ",
  Q93ucv: "ヨーロッパ/ダブリン",
  Q9eZjv: "アメリカ/リマ",
  QIrZ4x: "太平洋/コスラエ",
  QXW2mv: "アメリカ/アルゼンチン/トゥクマン",
  QlNyHt: "アジア/ソウル",
  RWGdDh: "ヨーロッパ/ブカレスト",
  RWhf30: "太平洋/オークランド",
  RbCEhx: "アメリカ/ケンタッキー/ルイビル",
  RdB8rs: "アメリカ/ケンタッキー/モンティセロ",
  Ri5GFC: "ヨーロッパ/ヴォルゴグラード",
  Rzjtg0: "南極/マッコーリー",
  "SB+r6t": "インド洋/クリスマス島",
  "SDmnE+": "アジア/アンマン",
  SO2rVX: "アフリカ/ウィントフック",
  TSIb1O: "アジア/ベイルート",
  TVzP2K: "太平洋/イースター島",
  TmXGJf: "太平洋/パゴパゴ",
  Tp6vAo: "大西洋/アゾレス",
  "Tvk1/+": "アジア/バクー",
  TxnfAW: "ヨーロッパ/シンフェロポリ",
  UU6RxP: "太平洋/ファカオフォ",
  "W+BF0N": "ヨーロッパ/キエフ",
  WF6jLL: "アジア/イルクーツク",
  WGbNbT: "ヨーロッパ/ローマ",
  WH83gM: "オーストラリア/ユークラ",
  WM9F6N: "ヨーロッパ/ブダペスト",
  WT4u2Q: "アフリカ/ビサウ",
  Wd588a: "アメリカ/ジュノー",
  "X+krOQ": "ヨーロッパ/ロンドン",
  XG3VTC: "インド洋/モルディブ",
  XGLQKt: "インド洋/モーリシャス",
  XJz9XQ: "アメリカ/シカゴ",
  XcLHzQ: "アメリカ/サントドミンゴ",
  XgCqrC: "アジア/クチン",
  "Xs2qb/": "アジア/上海",
  YUT4gj: "ヨーロッパ/リスボン",
  YZ2GGD: "アジア/シンガポール",
  "Ywxpi/": "インド洋/マヘ",
  Z0uRcM: "アジア/ダッカ",
  ZKdJhk: "アメリカ/ボアビスタ",
  ZZib2d: "オーストラリア/ホバート",
  Zjiy1h: "太平洋/ナウル",
  ZnA7Nz: "アジア/ヘブロン",
  a25tfu: "アジア/コルカタ",
  a4hALt: "ヨーロッパ/サマラ",
  aIkFIc: "ヨーロッパ/リガ",
  aJXo8B: "アジア/サハリン",
  an8KV9: "ヨーロッパ/ストックホルム",
  "bPKD9+": "アメリカ/バイーア",
  bpugpH: "太平洋/ガラパゴス",
  bwibOg: "アメリカ/インディアナ/テルシティ",
  bwxucD: "南極/ロゼラ",
  byIMHD: "アメリカ/インディアナ/ウィナマック",
  cGo7xU: "ヨーロッパ/ウィーン",
  cL4iBR: "太平洋/ウェーク",
  cR6lQr: "アメリカ/ニューヨーク",
  cY9R69: "アジア/ヤンゴン",
  "cdP+DQ": "メモリ負荷",
  cfqioE: "アメリカ/マルティニーク",
  ckkIgb: "アメリカ/サンタレン",
  "d+p45H": "南極/オーストラル",
  "dD/ri/": "太平洋/エファテ",
  dVOPAi: "デバイスオフライン監視",
  dmQidl: "太平洋/ウォリス",
  dnhrx5: "ヨーロッパ/アテネ",
  dsc2e1: "アメリカ/カンポグランデ",
  dwtkZ7: "大西洋/カーボベルデ",
  e7x56t: "アメリカ/エイルネペ",
  eCaCt4: "ヨーロッパ/コペンハーゲン",
  eJ850A: "アメリカ/カラカス",
  eUPrSB: "アメリカ/アルゼンチン/コルドバ",
  "eiH+8b": "アフリカ/ンジャメナ",
  esrASO: "アメリカ/マナウス",
  "f/kdJq": "アジア/ドゥシャンベ",
  f2wvqe: "アジア/クズロルダ",
  fRTjpp: "アメリカ/ポートオブスペイン",
  felOXC: "ヨーロッパ/ミンスク",
  "fr++q+": "アメリカ/ノースダコタ/センター",
  fwXmSX: "インド洋/レユニオン",
  g8yytK: "既読",
  g9Ro8s: "アジア/ティンプー",
  gCnWv3: "アメリカ/グアテマラ",
  "gWP+OK": "アメリカ/ポルトヴェーリョ",
  gY9Idz: "通知内容",
  hMJvQy: "アジア/アクトベ",
  hMvFT8: "太平洋/フィジー",
  i9kfO3: "オーストラリア/パース",
  ia2KGW: "オーストラリア/リンデマン",
  iemojj: "アメリカ/インディアナ/ピーターズバーグ",
  iktlFx: "アフリカ/ラゴス",
  ioR1tU: "オーストラリア/メルボルン",
  irTGxZ: "アメリカ/ナッソー",
  iuG5L2: "太平洋/フナフティ",
  jArote: "アジア/チョイバルサン",
  jGg3Qb: "大西洋/バミューダ",
  "kPnKK/": "太平洋/タラワ",
  kQfkBY: "太平洋/ニウエ",
  kX80z5: "アフリカ/カサブランカ",
  kb4vnt: "アジア/トビリシ",
  kibwvT: "アメリカ/アラグアイナ",
  klPlFN: "大西洋/マデイラ",
  ktaxSw: "未読",
  kzL66g: "アメリカ/シトカ",
  l0DTVX: "ヨーロッパ/キシナウ",
  l3HZXk: "アメリカ/アルゼンチン/フフイ",
  lUObgG: "アジア/ノヴォクズネツク",
  "lY+G1f": "ヨーロッパ/ザポリージャ",
  ldw5JF: "アメリカ/ハバナ",
  ldz3Qp: "アメリカ/ノーム",
  "luv+ak": "南極/ショウワ",
  m372k4: "アジア/アクタウ",
  mC90qt: "アメリカ/フェルナンドデノローニャ",
  maWrSV: "アジア/カタール",
  mpmcYh: "アメリカ/ジャマイカ",
  mzw9vO: "アジア/ウラジオストク",
  nFRGgT: "アジア/ニコシア",
  nG6bDa: "太平洋/ポンペイ",
  nNIaxy: "オーストラリア/カリー",
  "nTx/do": "アフリカ/モンロビア",
  ndfOI1: "アジア/タシケント",
  nfV4cd: "太平洋/ポートモレスビー",
  nt7Sni: "アメリカ/フェニックス",
  "oNgMl/": "ヨーロッパ/ワルシャワ",
  ox9xcC: "アジア/ウランバートル",
  "p/Y+A9": "アジア/オラル",
  p60kqM: "アメリカ/インディアナ/ノックス",
  "pDAAq+": "太平洋/クリスマス",
  "pH7u/B": "ヨーロッパ/プラハ",
  pctdGN: "太平洋/タヒチ",
  pkQvvT: "アジア/ガザ",
  qZesUE: "太平洋/ブーゲンビル",
  qm1rPH: "アメリカ/アダック",
  qrxb3P: "アメリカ/マナグア",
  qyspJO: "アジア/バグダッド",
  rB8hza: "アメリカ/ボイシ",
  rDnYpj: "アメリカ/デトロイト",
  "rSU+yK": "ヨーロッパ/ティラナ",
  rhrAj5: "アジア/マニラ",
  sCbQzB: "太平洋/グアム",
  ssEhAp: "オーストラリア/ダーウィン",
  tGy5jw: "アジア/ビシュケク",
  tb5CXr: "ヨーロッパ/パリ",
  u8OEeb: "アジア/アナディリ",
  umaIEg: "アメリカ/アルゼンチン/ウシュアイア",
  "uq/hF0": "アジア/東京",
  v1R8a6: "アメリカ/ガイアナ",
  v9QImt: "アジア/カブール",
  vvPXpH: "アジア/カトマンズ",
  w6MqYv: "アメリカ/ベレン",
  "wHl/4A": "オーストラリア/アデレード",
  wQ6hxa: "アフリカ/チュニス",
  wTov5v: "アメリカ/フォルタレザ",
  wu6z2j: "太平洋/ガンビエ",
  xC5dF9: "アフリカ/アルジェ",
  xV1AHg: "アジア/エカテリンブルク",
  xV72W5: "アメリカ/サンティアゴ",
  "xefyX+": "アメリカ/ノースダコタ/ビュラ",
  yBB7Af: "アメリカ/アルゼンチン/ラリオハ",
  yjTwMp: "アジア/台北",
  yk6eIX: "太平洋/ホノルル",
  z4BN1R: "アメリカ/ケイマン",
  zMTRSM: "CPU負荷",
  zOIpOr: "アメリカ/インディアナ/ヴィンセンヌ",
  zooIwl: "ヨーロッパ/ビリニュス",
  "/+bsEl": "アメリカ/モンテレー",
  "/Gtqfz": "アメリカ/メリダ",
  "22S38U": "アメリカ/アティコカン",
  "3TyuhP": "アメリカ/オヒナガ",
  "3nz5UA": "アフリカ/アビジャン",
  "5LGVs8": "アメリカ/イヌヴィク",
  "5hwp3A": "アメリカ/ウィニペグ",
  "75rZvt": "アメリカ/フォートネルソン",
  B1cpxi: "アメリカ/バイアバンデラス",
  DB1i32: "アメリカ/チワワ",
  EjYbG7: "大西洋/カナリア",
  JJlhYG: "アメリカ/モンクトン",
  JK7opY: "アメリカ/レイニーリバー",
  JMiQE7: "アメリカ/スウィフトカレント",
  JNgj9q: "アメリカ/バンクーバー",
  LQs9br: "アメリカ/クレストン",
  TV0vfT: "アメリカ/エルモシージョ",
  TtsBNI: "アメリカ/サンタイザベル",
  "V/ychw": "アメリカ/セントジョンズ",
  V3RDY8: "アメリカ/ケンブリッジベイ",
  WrrSc3: "ヨーロッパ/マドリード",
  XAJf4I: "アメリカ/イエローナイフ",
  Xf2rFn: "アメリカ/マサトラン",
  "YIziP+": "アメリカ/ランキン・インレット",
  Zw6GOE: "アメリカ/レジーナ",
  cvhrwM: "アメリカ/パンニルトゥング",
  d4TeTf: "アメリカ/ホワイトホース",
  dS4Q9B: "アメリカ/エドモントン",
  dXgU6w: "アメリカ/マタモロス",
  damxMJ: "アメリカ/ニピゴン",
  hrTtyK: "アメリカ/ドーソン・クリーク",
  i7y8PO: "アフリカ/セウタ",
  mYnwj6: "アメリカ/イカルイト",
  mZSYZK: "アメリカ/カンクン",
  n4UQqL: "アメリカ/ドーソン",
  pIep8S: "アメリカ/メキシコシティ",
  pZHBxH: "アメリカ/レゾリュート",
  puzgCP: "アメリカ/トロント",
  sf6FE5: "アメリカ/グレイス・ベイ",
  trLh1J: "アメリカ/ティファナ",
  vmXV5r: "アメリカ/ブラン・サブロン",
  x062Q4: "アメリカ/ハリファックス",
  x5t5ol: "アメリカ/サンダー・ベイ",
  x8MKpa: "アメリカ/グース・ベイ",
  qhku2P: "(Windows 7 はまだサポートされていません)",
  LjaYAu: "(設定を適用した後、デバイスは自動的に再起動します)",
  SsOQaU: "Android デバイスのパスを設定する必要があります",
  ftJgyV: "デバイスをチェックする必要があります",
  tp71Dv: "Windows デバイスのパスを設定する必要があります",
  "+x/2kt": "デバイス ルール",
  "781mpm": "3. 会社のデフォルトの命名規則",
  EJYMZz:
    "閉じた後、新しいバージョンの Ora をダウンロードして自分でインストールするか、デバイス コマンド - Ora update を使用して手動で更新できます。",
  QWNGGT: "デバイス数量",
  QkSHo2:
    "自動更新をオフにすると、デバイス上の Ora バージョンの違いにより、一部の機能が使用できなくなる可能性があります",
  RFear4: "2. デバイス更新期間 (現地時間)",
  VUYwkz: "アプリケーションを選択してください",
  Z8Wkvb:
    "オンにすると、Ora は自動的にダウンロードされ、新しいバージョンがある場合は更新されます。",
  bc4BgP: "Ora の最後のオンライン時間",
  c5daOt: "店舗数 ({num})",
  qDHqff: "自動再起動",
  zbqD5q: "値",
  FtTdh0: "1. {ora} は自動的に更新されます",
  Em0SLE: "再起動",
  Gvm3Ry:
    "({name}) の {appName} を再起動してもよろしいですか? アプリケーションの監視は再起動後も続行されます。",
  Ixi8kg: "再起動リマインダー",
  bbMhTk: "再起動してもよろしいですか?",
  "99tjyG": "IP",
  "9a/nvJ": "操作結果",
  BdDDD0: "デバイスログ",
  MbqxKj: "テンプレート名",
  OjLqmy: "不明",
  V6d4dz: "操作の詳細",
  "hD/l+2": "操作タイプ",
  "s+OQvW": "オペレーター",
  yc8eep: "結果を選択",
  "/5RjKG": "トケンの故障",
  "0nwYmb": "すべての通知タイプ",
  "ZC7J/S": "通知タイプ",
  pm5kAg: "詳細はこちら",
  y8e4w8: "デバイスの再起動後にのみ有効になります",
  vjxfR4: "（exeインストーラ、msiファイル）",
  "8DORrA": "USBポート",
  AFx0WP: "検索タイプ",
  GyqBiS: "情報を印刷する",
  L3HWwz: "デバイスの説明",
  OuXnTb: "この USB ポートをリセットしてもよろしいですか?",
  "QZM++f": "プリンターをリセットしてもよろしいですか?",
  RCjVsb: "デバイスID",
  RJpihQ: "この USB ポートを無効にしてもよろしいですか?",
  adMZWx: "周辺機器を追加",
  j3iWkN: "プリンタを繰り返すことはできません",
  kL3ndq: "このプリンターを削除しますか?",
  r8lAlx: "周辺機器管理",
  wIFJtf: "接続されていません",
  zKsJJS: "この USB ポートを有効にしてもよろしいですか?",
  "zY36V+": "接続済み",
  "2Rco7+": "アップロード時間:",
  "5JrKIs": "機能の展開は、選択したリリース時間にスケジュールされています。",
  E62yo0: "関数のデプロイメントに失敗しました。再試行しています。",
  HI9nIp: "ファイルを削除",
  IX5jed: "構成ファイルの展開ステータス",
  Mxw3XE: "bat ファイルの名前が install または uninstall ではありません",
  "N3h+Aq": "関数の展開に失敗しました",
  N9kr00: "転送後にアプリをアンインストールする",
  "OY+bYK": "確認、再度表示しない",
  PZD5BD:
    "このプロジェクトは [{name}] 構成ファイルで使用されているため、削除できません。プロジェクトを削除する場合は、構成ファイルから削除してください",
  Pzsa4g: "機能の展開準備ができました",
  RzXkm3: "ブラックリストが有効",
  SzN0Xf: "デバイス所有者を削除",
  VvutjQ: "関数",
  XPoLPc: "機能の展開が受信され、すぐに処理されます。",
  Xsx53E: "このファイルを削除してもよろしいですか?",
  c7ABGP: "関数の展開はOraの応答を待っています",
  d6mNdO: "ホワイトリストが有効",
  f9tP6e: "この Windows アプリケーションを削除してもよろしいですか?",
  hmCei2: "削除後にアプリをアンインストールする",
  ii1TCF:
    "(圧縮パッケージ内の bat ファイルに install または uninstall という名前を付けてください)",
  mmGD7U: "機能の展開が進行中です。",
  uL4MGN: "この Android アプリケーションを削除してもよろしいですか?",
  wzPSgE: "ブラックリスト/ホワイトリスト",
  xAk1ic: "機能は正常に展開されました",
  yWzW01: "(exe インストーラー、msi ファイル、zip 圧縮パッケージ)",
  yvnu2T: "設定テンプレート名",
  "CqT/5i":
    "このファイルは共有されています。このファイルを削除してもよろしいですか?",
  wboZY3: "レポート時間",
  "6kNt8v": "次の1時間",
  Rkh3mc: "最後の1時間",
  "+/nbWD": "次回変更可能時刻 {time}",
  "1ULJr+": "シングルアプリケーションモード",
  CxuMXm: "アプリケーションを追加する必要があります",
  Gp3iu0: "ローカル壁紙をアップロード",
  M0GExq:
    "デバイスに既にアプリがインストールされている場合は、元のバージョンを削除して再インストールしてください",
  OYWCEU: "ローカルアップロードアプリケーション",
  PyHYs3: "VNC接続を切断",
  QZCAIP: "アプリケーションID",
  "X+8ega": "キオスクモードの選択",
  "bLP2/B": "設定アプリケーションの状態を確認してください",
  bneXBI: "プロンプトを変更",
  czLSET: "アプリケーションを手動で追加",
  eg9Cwk: "現在地の会社から",
  f8ijF3: "コマンドが発行されました",
  i8wqAy: "ローカルアプリケーションをアップロード",
  oiRBSj:
    "確認後、デバイスは新しいアプリケーションを適用します設定。適用してもよろしいですか？",
  "qG2/EZ": "ローカルファイルアップロード",
  "qH+vs7": "ホワイトリスト",
  qTgFpp: "アカウントが所属する会社から",
  qwHBkg:
    "設定変更の記録はありません。すべてのデバイスでデフォルト設定が使用されます",
  sB85Wu: "ローカルアップロード",
  uqEE8V: "この設定はAndroid Ora 2.14.25にのみ適用されます",
  vtUGfp: "会社のデフォルトの命名規則",
  QgHuyM: "ストアの命名規則",
  "+Bas2b": "再生時間: {duration}",
  "+a6DnG": "審査中",
  "/CFd+q": "開く",
  "0JQoTX": "審査失敗",
  "0Ru5zG": "サイズ: {size}",
  "0UhE3z": "再生ステータス",
  "0btyN9": "再生時間:",
  "1/U2kj": "動画",
  "1qoi3T": "画像",
  "3HqLlX": "新規コンテンツ",
  "4jU7ke": "コンテンツプレーヤーを起動",
  "4nG/GN": "コンテンツ名",
  "5RR9aM": "一括一時停止",
  "5XSNyG": "素材のアップロードに成功しました",
  "6K/a0B": "一時停止",
  "6wAcmz": "時間を選択してください",
  "7M1nFY": "テンプレートを削除してもよろしいですか？ {name} ですか？",
  "7OW60G": "選択時間をクリア",
  "7Ouq4k": "順序: {sort}",
  "7cAtfM": "時間",
  "7wofGo": "アプリケーション",
  "9c8SPP": "サイズ",
  BhWZJo: "リソース名",
  C55Kjj: "再生コンテンツ",
  "D+32Ow": "リソース管理センター",
  EBMdAL: "作成に成功しました",
  ECm6hH: "このリソース ({name}) を削除してもよろしいですか？",
  "ELFG/t": "デバイスを検索",
  IP9Kbk: "画像は15MBを超えることはできません",
  Ie9WHB: "素材をアップロード",
  KOVFgK: "レビュー待ち",
  "Lqca+c": "プレーヤー切り替え",
  MDACCo: "再生に成功しました",
  MWJG8I: "名前: {name}",
  "Ut8+i2": "承認済み",
  "Xi/+KE": "時間帯を追加",
  YuZxve: "コンテンツを選択",
  bKLb1C: "再生",
  bYujGa: "テンプレートを作成",
  fFaC3Z: "再生時間",
  gVXoXc: "コンテンツ管理",
  i9lOCU: "選択した開始日は今日より前です",
  iHQiQV: "一括再生",
  iJIOBp: "解析に失敗しました",
  "iRR+fJ": "debugInfo",
  l9XE8F: "承認済み",
  lchpP8: "正常に適用されました",
  m8CFrl: "新しいテンプレートを作成",
  nbp4U6: "コンテンツテンプレートリスト",
  oUgWVb: "タイプ: {type}",
  "p/EHrl": "動画の最大サイズは10GB",
  qx5UwR: "デバイスを選択してください",
  rBWtYz: "最終変更時刻",
  rnpMD3: "オフ",
  sux9FA: "下限値を入力してください: 1",
  tRm3bw: "一時停止に成功しました",
  uhTa0i: "プレビュー",
  w1cMGO: "終了日",
  ztKQno: "期間",
  J3dxzb:
    "Nubisは現在、JPEGとPNGの画像形式をサポートしています。動画はH.264コーデックを使用してエンコードする必要があります。サポートされているファイル形式には、MPEG-4とMOVが含まれます。コーデックとは、データを圧縮して高速伝送し、受信したデータを元の形式に解凍するソフトウェアまたはハードウェアです。H.264コーデックは、動画コンテンツの録画、圧縮、配信によく使用されます。動画ファイル形式には、1つ以上のコーデックが含まれている場合があります。MOVまたはMPEG-4の動画ファイルが審査に不合格になった場合は、動画のエンコードに使用されているコーデックがH.264であることを確認してください。",
  "M5Vtr/": "テンプレートの編集",
  b1xi4S: "テンプレートのプレビュー",
  kNhfaL: "テンプレート（{name}）を削除してもよろしいですか？",
  kqgd4D: "実行時間を少なくとも1つ追加してください。",
  "36pf2y": "コンテンツ履歴",
  "3izvEF": "ファイルを選択",
  "9mG+jv": "ファイルサイズが空き容量を超えています",
  AlFkwq: "インストール済みデバイスの数",
  C8ZuKU: "画像の幅",
  E0Czos: "画像の高さ",
  I73XLQ: "画像のY軸",
  JbroVc: "Nubis Cast",
  MMqJtu: "画像または動画を選択してください",
  "Pv/1oy": "コンテンツの表示",
  Rrwy85: "作成者",
  T8Y38H: "画像ファイル (*.jpg/*.png)",
  VJ7wHx: "インストールするデバイスの数",
  WI3Hl5: "動画のY軸",
  "Y2Wh/g": "動画ファイル (*.mp4/*.mov)",
  "YLvNj+": "インストール予定デプロイ済み",
  kUbrNT:
    "ファイルをまずリソース管理センターにアップロードしてください。テンプレートとして使用できるのは承認されたファイルのみです。",
  n997QX: "ビデオの高さ",
  rBD8kj: "画像の水平軸",
  uCmncQ: "ビデオの幅",
  QwmhEP: "コンテンツ履歴",
  "8vC+0s": "再生コンテンツを選択する必要があります",
  "jG/AFY": "確認後、デバイスに新しい設定が適用されます。1日以内は変更できません。適用してもよろしいですか？",
  "AxZAkZ": "このプラットフォームにアップロードされたデジタルコンテンツは、Amazon Rekognitionコンテンツモデレーションによって自動的に審査され、公開リスクを軽減します。自動審査が失敗した場合は、手動で審査することもできますが、その場合、このプラットフォームはその後の影響について一切責任を負いません。",
  "Oyd/7c": "手動承認",
  "wyHcKZ": "承認リマインダー",
  "32HMy/": "{nubis} キャストバージョン",
  "IS73A4": "開始時刻は終了時刻より後にできません",
  "jCAPQ2": "{nubis} キャストモード",
  "sWmzFs": "{ora} 最終更新時刻",
  "sctjLN": "{ora} 最終オンライン時刻",
  "uoBkfP": "{ora} 最終更新ステータス",
  "3yichR": "最終更新日時",
  "d+otpZ": "リリースバージョン",
  "k30s+D": "最終公開日時",
  "9bgunT": "無効にした場合、{ora} の最新バージョンを手動でダウンロードしてインストールするか、デバイスコマンド「{ora} update」を使用して手動で更新できます。",
  "Yh8vRi": "有効にした場合、{ora} の新しいバージョンが利用可能になると、自動的にダウンロードして更新されます。",
  "ZO2gEn": "{nubis} バージョン",
  "r+yR7v": "{nubis} Cast",
  "uf58G7": "自動更新が無効になっている場合、デバイス上の {ora} のバージョンの違いにより、一部の機能が利用できなくなる可能性があります。",
  "y98D3X": "ビデオの垂直軸"
};
